import React, { Component, useEffect } from 'react';
import { Card, Col, Row } from "antd";
import '../components-style.css';
import { Nav, NavItem, NavLink, TabContent, TabPane} from 'reactstrap';
import { Icon } from 'semantic-ui-react';
import {FormattedMessage, defineMessages} from 'react-intl';

import { Tooltip } from                 'react-tooltip'
import { FaTemperatureHalf } from       'react-icons/fa6';
import { FaHeartPulse } from            'react-icons/fa6';
import { GiBackPain, GiKidneys } from   'react-icons/gi';
import { RiSurveyLine } from            'react-icons/ri';
import { FaWeightScale } from           'react-icons/fa6';
import { FaCamera } from                'react-icons/fa';
import blood_pressure from              '../../Images/BloodPressure/blood-pressure.png';
import { FaLungs } from                 "react-icons/fa";
import { FaMaskVentilator } from        'react-icons/fa6'

import AlertManager from                '../Alerts/alertManagerFrontend.js';

import PostDataController from          '../../Controller/PostDataController.js'
import GetDataController from           '../../Controller/getPatientGenericData.js'

//Profile data display
import ProfileParameters from           './PatientParamsDisplay.js';
import TimerDisplay from                '../Common/TimerDisplay.js';
import GraphOneCurve from               '../Common/GraphOneCurve.js';
import GraphOneBar from                 '../Common/GraphOneBar.js';
import GraphTwoBars from                '../Common/GraphTwoBars.js';
import GraphTwoCurves from              '../Common/GraphTwoCurves.js';
import GraphThreeCurves from            '../Common/GraphThreeCurves.js';

import TuckyDataManager from            '../Tucky/TuckyDataManager.js';
import CopyableId from                  '../Common/CopyableId.js';
import { userIsSuperAdmin } from        '../../Controller/userRoles.js';
import TemperatureDisplay from          '../Tucky/TemperatureDisplay.js';
import MaxTemperatureLast3h from        '../Tucky/maxTemperatureLast3h.js';
import PositionDisplay from             '../Tucky/PositionDisplay.js';
import BatteryDisplay from              '../Tucky/BatteryDisplay.js';

import PulseOximeterManager from        '../PulseOximeter/pulseOximeterManager.js'
import Sp02Display from                 '../PulseOximeter/Sp02Display.js';
import PulseRateDisplay from            '../PulseOximeter/PulseRateDisplay.js';

import TensionManager from              '../Tensiometer/TensiometerManager.js'
import TensionDisplay from              '../Tensiometer/tensionDisplay.js';

import ScaleManager from                '../Scale/ScaleManager.js';
import WeightDisplay from               '../Scale/WeightDisplay.js';

import PainManager from                 '../Pain/PainManager.js';

import BreathingManager from           '../Niv/BreathingManager.js';

import HealthFormManager from           '../Healthform/HealthformManager.js';
import EQ5DResDisplay from              '../Healthform/EQ5DResDisplay.js';
import EQ5DHealthscaleDisplay from      '../Healthform/EQ5DHealthscaleDisplay.js';
import EQ5DDisplayNewForm from          '../Healthform/EQ5DDisplayNewForm.js';
import SF36ResDisplay from              '../Healthform/SF36ResDisplay.js';
import SF36DisplayNewForm from          '../Healthform/SF36DisplayNewForm.js';
import MDASIResDisplay from              '../Healthform/MDASIResDisplay.js';
import MDASIDisplayNewForm from         '../Healthform/MDASIDisplayNewForm.js';
import AlimentationDisplayNewForm from  '../Healthform/AlimentationDisplayNewForm.js';
import AlimentationResDisplay from      '../Healthform/AlimentationResDisplay.js';
import NivBreathingRateResDisplay from  '../Niv/NivBreathingRateResDisplay.js';
import AhiIndexResDisplay from  '../Niv/AhiIndexResDisplay.js';
import NivBreathingLeakageResDisplay from  '../Niv/NivBreathingLeakageResDisplay.js';
import NivBreathingUsageResDisplay from '../Niv/NivBreathingUsageResDisplay.js';
import NivDisplayNewForm from           '../Niv/NivDisplayNewForm.js';
import OxiResDisplay from               '../Oxi/OxiResDisplay.js';
import OxiUsageDisplay from             '../Oxi/OxiUsageDisplay.js';
import OxiDisplayNewForm from           '../Oxi/OxiDisplayNewForm.js';
import KidneyMachineDisplayNewForm from '../Kidney/KidneyMachineDisplayNewForm.js';
import KidneyBloodDisplayNewForm from   '../Kidney/KidneyBloodDisplayNewForm.js';

import PhotographyDataManager from      '../Photo/PhotographyDataManager.js';
import PhotoCarousel from               '../Photo/PhotoCarousel.js';

import CameraPopup from                 '../Photo/CameraPopup.js';

import { Range, getTrackBackground } from 'react-range';

import Utils from '../Common/Utils.js';
import KidneyDisplayTables from '../Kidney/KidneyDisplayTables.js';
import PatientProfileModal from './PatientProfileModal.js';
import GraphPopup from '../Common/GraphPopup.js';

class Profile extends Component {

    constructor(props) {
        super(props);                                                            
        
        this.state = {
            displayDevicesParams: props.profileData.Patient_Data.monitoring_activation,

            changeOngoing: false,

            // Zoomable graph popup (loupe icon)
            graphPopup: null,

             // Thermometer states
            temperatureDisplay: {
                temperature : "-",
                color: "#767676"  
            },
            maxTemperatureLast3h: {
                temperature : "-",
                color: "#767676"                
            },
            batteryLevelDisplay: "-",
            positionDisplay: "-",
            temperatureTimerDisplay: "-",

            // PulseOxymeter states
            pulseRateDisplay: {
                pulseRate: "-",
                color: "#767676"
            },
            spo2Display: {
                spo2: "-",
                color: "#767676"
            },       
            spo2PrTimerDisplay: "-",

            // Tensiometer states
            pulseRateDisplayTensiometer: {
                pulseRate: "-",
                color: "#767676"
            },
            tensionDisplay: {
                systolic: "-",
                diastolic: "-",
                color: "#767676"
            },
            tensionTimerDisplay: "-",

            // scale states
            weightDisplay: {
                weight: "-",
                color: "#767676"
            },  
            weightTimerDisplay: "-",

            // pain states
            painLevel: [2],
            painLevelChanged: false,
            painTimerDisplay: "-",

            // form states
            formresDisplay: {
                res: "-",
                color: "#767676"
            },
            healthscaleDisplay: {
                healthscale: "-",
                color: "#767676"
            },
            formTimerDisplay: "-",

            //form sf36 states
            formresSF36Display: {
                res: "-",
                color: "#767676"
            },
            formSF36TimerDisplay: "-",

            //form mdasi states
            formresMDASIDisplay: {
                res: "-",
                color: "#767676"
            },
            formMDASITimerDisplay: "-",

            //form alimentation states
            formresAlimentationDisplay: {
                res: "-",
                color: "#767676"
            },
            formAlimentationTimerDisplay: "-",

            //form niv states
            breathingUsageNivDisplay: {
                res: "-",
                color: "#767676"
            },
            breathingLeakNivDisplay: {
                res: "-",
                color: "#767676"
            },
            breathingRateNivDisplay: {
                res: "-",
                color: "#767676"
            },
            ahiIndexDisplay: {
                res: "-",
                color: "#767676"
            },
            formNivTimerDisplay: "-",

            //form Oxi states
            formresOxiUsageDisplay: {
                res: "-",
                color: "#767676"
            },
            formresOxiBreathingRateDisplay: {
                res: "-",
                color: "#767676"
            },
            formOxiTimerDisplay: "-",

            // alert states
            frontend_alert_state: {           /* Contains alerts states (true or false) to control alert display */
                fever: {
                    triggered: false,
                    first_detect_time : "none",
                    active_rest_duration: false,
                    last_read_time : ""
                },                 
                detach: {
                    triggered: false,
                    first_detect_time : "none",
                    active_rest_duration: false,
                    last_read_time : ""
                },
                battery: {
                    triggered: false,
                    first_detect_time : "none",
                    active_rest_duration: false,
                    last_read_time : ""
                },
                position: {
                    triggered: false,
                    first_detect_time : "none",
                    active_rest_duration: false,
                    last_read_time : ""
                },                 
                pulseRate: {
                    triggered: false,
                    first_detect_time : "none",
                    active_rest_duration: false,
                    last_read_time : ""
                },
                spo2: {
                    triggered: false,
                    first_detect_time : "none",
                    active_rest_duration: false,
                    last_read_time : ""
                },
                pulseRateTension: {
                    triggered: false,
                    first_detect_time : "none",
                    active_rest_duration: false,
                    last_read_time : ""
                },
                bloodpressure_sys_high: {
                    triggered: false,
                    first_detect_time : "none",
                    active_rest_duration: false,
                    last_read_time : ""
                },
                bloodpressure_dia: {
                    triggered: false,
                    first_detect_time : "none",
                    active_rest_duration: false,
                    last_read_time : ""
                },
                reminder: {
                    triggered: false,
                    first_detect_time : "none",
                    active_rest_duration: false,
                    last_read_time : ""
                },
                weight: {
                    triggered: false,
                    first_detect_time : "none",
                    active_rest_duration: false,
                    last_read_time : ""
                },
                eq5d: {
                    triggered: false,
                    first_detect_time : "none",
                    active_rest_duration: false,
                    last_read_time : ""
                },
                eq5d_scale: {
                    triggered: false,
                    first_detect_time : "none",
                    active_rest_duration: false,
                    last_read_time : ""
                },
                sf36: {
                    triggered: false,
                    first_detect_time : "none",
                    active_rest_duration: false,
                    last_read_time : ""
                },
                mdasi: {
                    triggered: false,
                    first_detect_time : "none",
                    active_rest_duration: false,
                    last_read_time : ""
                },
                pain: {
                    triggered: false,
                    first_detect_time : "none",
                    active_rest_duration: false,
                    last_read_time : ""
                },
                breathing_rate: {
                    triggered: false,
                    first_detect_time : "none",
                    active_rest_duration: false,
                    last_read_time : ""
                },
                breathing_oxygen_rate: {
                    triggered: false,
                    first_detect_time : "none",
                    active_rest_duration: false,
                    last_read_time : ""
                },
                breathing_leakage: {
                    triggered: false,
                    first_detect_time : "none",
                    active_rest_duration: false,
                    last_read_time : ""
                }
            },
            activeTab: Utils.getFirstTabWithData(props.subscription_info.features, props.profileData.Patient_Data),                      //Control activated tab: first tab (temperature) carrying data, refined once data is loaded
            lastBreathingUsageDataDate: 0,
            selectedPicture: 0,
            showProfileModal: false
        };

        this.audio;

        this.handleClick = this.handleClick.bind(this);
        this.changeDisplayDevices = this.changeDisplayDevices.bind(this);
        this.handleTabSwitch = this.handleTabSwitch.bind(this);
        this.handleCarrouselChange = this.handleCarrouselChange.bind(this);
        this.handleChangeOngoing = this.handleChangeOngoing.bind(this);
        this.getProfileWidth = this.getProfileWidth.bind(this);
        this.intervalID = 0;
        // Whether the data-aware default tab has already been picked. Set once after the
        // first full data load, and forced true as soon as the user switches tab manually,
        // so the auto-selection never overrides a clinician's choice.
        this.defaultTabApplied = false;

    }

    async componentDidMount(){               

        this.audio = AlertManager.getAudioInstance();
        this.refreshData(true);

        //Function to refresh each profile at regular time
        this.intervalID = setInterval(async () => {
         
            this.refreshData(false);

        }, 40000) /* Reactualize every 40 000 ms */
    }

    //Clear interval when component is destroyed
    componentWillUnmount() {
        clearInterval(this.intervalID);
    }


    //Update the patientbox if the date selected changes
    async componentDidUpdate(prevProps){
        if (prevProps.dateSelected !== this.props.dateSelected) {
            this.refreshData(true);
        }
        //TMP
        //keeping medical data when changes occurs
        //temperature
        if (prevProps.profileData.Patient_Data.thermometer.length !== 0 && prevProps.profileData.Patient_Data.thermometer !== this.props.profileData.Patient_Data.thermometer) {
            this.props.profileData.Patient_Data.thermometer = prevProps.profileData.Patient_Data.thermometer
        }
        //oximeter
        if (prevProps.profileData.Patient_Data.pulseOximeter.length !== 0 && prevProps.profileData.Patient_Data.pulseOximeter !== this.props.profileData.Patient_Data.pulseOximeter) {
            this.props.profileData.Patient_Data.pulseOximeter = prevProps.profileData.Patient_Data.pulseOximeter
        }
        //tensiometer
        if (prevProps.profileData.Patient_Data.pulseTensiometer.length !== 0 && prevProps.profileData.Patient_Data.pulseTensiometer !== this.props.profileData.Patient_Data.pulseTensiometer) {
            this.props.profileData.Patient_Data.pulseTensiometer = prevProps.profileData.Patient_Data.pulseTensiometer
        }
        //weight
        if (prevProps.profileData.Patient_Data.scale_data.length !== 0 && prevProps.profileData.Patient_Data.scale_data !== this.props.profileData.Patient_Data.scale_data) {
            this.props.profileData.Patient_Data.scale_data = prevProps.profileData.Patient_Data.scale_data
        }
        //pain
        if (prevProps.profileData.Patient_Data.pain.length !== 0 && prevProps.profileData.Patient_Data.pain !== this.props.profileData.Patient_Data.pain) {
            this.props.profileData.Patient_Data.pain = prevProps.profileData.Patient_Data.pain
        }
        //healthform eq5d
        if (prevProps.profileData.Patient_Data.eq5d.length !== 0 && prevProps.profileData.Patient_Data.eq5d !== this.props.profileData.Patient_Data.eq5d) {
            this.props.profileData.Patient_Data.eq5d = prevProps.profileData.Patient_Data.eq5d
        }
        //healthform sf36
        if (prevProps.profileData.Patient_Data.sf36.length !== 0 && prevProps.profileData.Patient_Data.sf36 !== this.props.profileData.Patient_Data.sf36) {
            this.props.profileData.Patient_Data.sf36 = prevProps.profileData.Patient_Data.sf36
        }
        //healthform mdasi
        if (prevProps.profileData.Patient_Data.mdasi.length !== 0 && prevProps.profileData.Patient_Data.mdasi !== this.props.profileData.Patient_Data.mdasi) {
            this.props.profileData.Patient_Data.mdasi = prevProps.profileData.Patient_Data.mdasi
        }
        //healthform alimentation
        if (prevProps.profileData.Patient_Data.alimentation.length !== 0 && prevProps.profileData.Patient_Data.alimentation !== this.props.profileData.Patient_Data.alimentation) {
            this.props.profileData.Patient_Data.alimentation = prevProps.profileData.Patient_Data.alimentation
        }
        //healthform breathing
        if (prevProps.profileData.Patient_Data.breathing.length !== 0 && prevProps.profileData.Patient_Data.breathing !== this.props.profileData.Patient_Data.breathing) {
            this.props.profileData.Patient_Data.breathing = prevProps.profileData.Patient_Data.breathing
        }
        //kidney device
        if (prevProps.profileData.Patient_Data.kidney_device.length !== 0 && prevProps.profileData.Patient_Data.kidney_device !== this.props.profileData.Patient_Data.kidney_device) {
            this.props.profileData.Patient_Data.kidney_device = prevProps.profileData.Patient_Data.kidney_device
        }
        //kidney blood
        if (prevProps.profileData.Patient_Data.kidney_blood.length !== 0 && prevProps.profileData.Patient_Data.kidney_blood !== this.props.profileData.Patient_Data.kidney_blood) {
            this.props.profileData.Patient_Data.kidney_blood = prevProps.profileData.Patient_Data.kidney_blood
        }
        //photography
        if (prevProps.profileData.Patient_Data.photo.length !== 0 && prevProps.profileData.Patient_Data.photo !== this.props.profileData.Patient_Data.photo) {
            this.props.profileData.Patient_Data.photo = prevProps.profileData.Patient_Data.photo
        }
    }

    changeDisplayDevices(display){
        this.setState(state => ({
            displayDevicesParams: display
        }))
    }

    //Function to remove alert display when button is clicked
    handleClick(e) {
        e.preventDefault();

        // reset audio alert
        AlertManager.resetAudioAlert(this.audio);        

        //reset alert trigs
        let reset_Alerts = this.state.frontend_alert_state
        reset_Alerts.position.triggered = false        
        reset_Alerts.fever.triggered = false
        reset_Alerts.detach.triggered = false
        reset_Alerts.battery.triggered = false
        reset_Alerts.pulseRate.triggered = false
        reset_Alerts.spo2.triggered = false
        reset_Alerts.pulseRateTension.triggered = false
        reset_Alerts.bloodpressure_sys_high.triggered = false
        reset_Alerts.reminder.triggered = false
        reset_Alerts.weight.triggered = false    
        reset_Alerts.eq5d.triggered = false
        reset_Alerts.eq5d_scale.triggered = false
        reset_Alerts.sf36.triggered = false
        reset_Alerts.mdasi.triggered = false
        reset_Alerts.pain.triggered = false
        reset_Alerts.breathing_rate.triggered = false
        reset_Alerts.breathing_oxygen_rate.triggered = false
        reset_Alerts.breathing_leakage.triggered = false

        this.setState(state => ({
            frontend_alert_state: reset_Alerts
        }));
    }

    handleChangeOngoing(status) {
        this.setState(state => ({
            changeOngoing: status
        }));
    }

    //Function to remove alert display when button is clicked
    handleTabSwitch(tabnum) {
        // A manual switch locks the tab: the data-aware default must never override it.
        this.defaultTabApplied = true;
        this.setState(state => ({
            activeTab: tabnum
        }))
    }

    //Function to change selected picture in carrousel
    handleCarrouselChange(pictureIndex) {
        this.state.selectedPicture = pictureIndex
    }

    //Function to filter the data, from all to a specific type
    filterDataContains(allData, type) {
        let ret = []
        allData.forEach(data => {
            let i = 0
            while (type[i]) {
                if (data.type.includes(type[i])) {
                    ret.push(data)
                }
                i++;
            }
        })
        return (ret)
    }

    //Function to handle data loading and refresh
    async refreshData(fullLoad){

        //Date variables
        const twelveHoursInMs = 43200000;
        let current_Date = new Date();

        let requestDateStart;
        let requestDateEnd;        

        if (fullLoad) {
            // First load: complete data load with cases "did mount" & "change date" (including today or not)
            requestDateStart = new Date (this.props.dateSelected[0]);
            requestDateEnd  = new Date (this.props.dateSelected[1]);
        }
        else{
            // Refresh loads: load only last 12 hours
            requestDateStart = new Date(current_Date.getTime() - twelveHoursInMs);
            requestDateEnd = new Date(current_Date.getFullYear(), current_Date.getMonth(), current_Date.getDate(), 23, 59, 59, 999);
        }

        let selectedDateStart = new Date(this.props.dateSelected[0]);
        let selectedDateEnd = new Date(this.props.dateSelected[1]);

        //Periodic log
        if (process.env.NODE_ENV === 'development'){
            console.log("refreshData " + fullLoad + " of " + this.props.profileData.Patient_Data.firstname);
            console.log(this.props.accountInformation)
            console.log(this.props.profileData);
            console.log(this.state.frontend_alert_state)
        }


        // Get all data
        let all_data_request = [];
        if (fullLoad || this.props.profileData.Patient_Data.monitoring_activation !== "no") {
            all_data_request = await GetDataController.get_patient_generic_Data(this.props.profileData.Patient_Data.id_patient, requestDateStart, requestDateEnd, Utils.getFHIRCodesFromFeatures(this.props.subscription_info.features));
        }

        /////////////////////// VARIABLES ///////////////////////
        let local_alert_state = this.state.frontend_alert_state

        // ******************************************************************//
        // *************************** TUCKY or AOJ20 ***********************//
        // ******************************************************************//  
        let connection_State
        let lastPositionData = []
        let lastBatteryData = []

        if ((this.props.profileData.Patient_Data.devices.device1.id !== 'dissociate')||(this.props.profileData.Patient_Data.monitoring_activation === 'smartphone')||(this.props.profileData.Patient_Data.monitoring_activation === 'no_device')||(fullLoad)) {

            // 1- GET DATA
            
            // Get temperature
            let temperature_data_request = Utils.filterData(all_data_request, "8310-5")

            // Get battery and position depending on connection state
            let battery_data_request = []
            let position_data_request = []
            connection_State = TuckyDataManager.getConnectionState(temperature_data_request);             
            if(connection_State === "connected"){
                // Battery
                battery_data_request = Utils.filterData(all_data_request, "8418512.6")
                // Position
                position_data_request = Utils.filterData(all_data_request, "72282-7")
            }
            
            // 2- FORMAT & MERGE DATA WHEN FULLLOAD OR SAME DAY
            if ( (fullLoad) || (Utils.isSameDay(current_Date, selectedDateEnd)) ) {
                this.props.profileData.Patient_Data.thermometer    = TuckyDataManager.formatAndMergeTemperatureData(fullLoad, this.props.profileData.Patient_Data.thermometer, temperature_data_request);
                this.props.profileData.Patient_Data.battery        = TuckyDataManager.formatAndMergeBatorPosData(fullLoad, this.props.profileData.Patient_Data.battery, battery_data_request);
                this.props.profileData.Patient_Data.position       = TuckyDataManager.formatAndMergeBatorPosData(fullLoad, this.props.profileData.Patient_Data.position, position_data_request);
            }
            battery_data_request = null;
            position_data_request = null; 

            // 3- ALERT CHECKING
            // Fever alert
            local_alert_state.fever = AlertManager.manageFrontendAlerts(local_alert_state.fever, this.props.profileData.Patient_Data.alerts.fever_alert, "fever_alert", this.props.profileData.Patient_Data.thermometer, this.audio, this.props.profileData.Patient_Data.alerts.sound_alert);
            // detach alert
            local_alert_state.detach = AlertManager.manageFrontendAlerts(local_alert_state.detach, this.props.profileData.Patient_Data.alerts.detach_alert, "detach_alert", this.props.profileData.Patient_Data.thermometer, this.audio, this.props.profileData.Patient_Data.alerts.sound_alert);
            // Battery alert
            local_alert_state.battery = AlertManager.manageFrontendAlerts(local_alert_state.battery, this.props.profileData.Patient_Data.alerts.battery_alert, "battery_alert", this.props.profileData.Patient_Data.battery, this.audio, this.props.profileData.Patient_Data.alerts.sound_alert);
            // Position alert                           
            if (TuckyDataManager.checkPositionAlert(this.props.profileData.Patient_Data.alerts.pos_alert, this.props.profileData.Patient_Data.position)){
                let trigData = [{x:new Date(), y:100}] // random data to trig alert
                local_alert_state.position = AlertManager.manageFrontendAlerts(local_alert_state.position, this.props.profileData.Patient_Data.alerts.pos_alert, "pos_alert", trigData, this.audio, this.props.profileData.Patient_Data.alerts.sound_alert);
            }

            // 4- BANNER DISPLAY
            if (this.props.profileData.Patient_Data.thermometer !== undefined){
                this.setTuckyData(
                    TuckyDataManager.getLastTemperatureDataAndColor(this.props.profileData.Patient_Data.thermometer, this.props.profileData.Patient_Data.alerts.fever_alert.threshold, this.props.profileData.Patient_Data.alerts.fever_alert.threshold2),
                    MaxTemperatureLast3h.getMaxTemperatureLast3h(this.props.profileData.Patient_Data.thermometer, this.props.profileData.Patient_Data.alerts.fever_alert.threshold, this.props.profileData.Patient_Data.alerts.fever_alert.threshold2),
                    TuckyDataManager.getLastbatteryAndPosition(connection_State, this.props.profileData.Patient_Data.battery, this.props.profileData.Patient_Data.position),
                    Utils.setLastMeasurementTimer(this.props.profileData.Patient_Data.thermometer)
                );
            }
            connection_State = null;

            // update alert curve with time (must be here to allow real time date change)
            this.props.profileData.Patient_Data.MaxFeverDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profileData.Patient_Data.alerts.fever_alert.threshold);
        }

        // ***************************************************************************************************************************************************************************//


        // ******************************************************************//
        // *************************** PULSE OX  ****************************//
        // ******************************************************************//  
        if ((this.props.profileData.Patient_Data.devices.device2.id !== 'dissociate')||Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("niv"))||Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("oxigen_therapy"))||(fullLoad)){

            // 1- GET DATA
            let PrSp02_data_request = Utils.filterData(all_data_request, "2708-6")

            // 2- FORMAT & MERGE DATA WHEN FULLLOAD OR SAME DAY
            if ( (fullLoad) || (Utils.isSameDay(current_Date, selectedDateEnd)) ) {
                this.props.profileData.Patient_Data.pulseOximeter    = PulseOximeterManager.formatAndMergeOximeterData(fullLoad, this.props.profileData.Patient_Data.pulseOximeter, PrSp02_data_request);
            }
            PrSp02_data_request = null; 

            // 3- ALERT CHECKING
            // Pulse rate alert
            local_alert_state.pulseRate = AlertManager.manageFrontendAlerts(local_alert_state.pulseRate, this.props.profileData.Patient_Data.alerts.PR_alert, "PR_alert", this.props.profileData.Patient_Data.pulseOximeter.pulseRate, this.audio, this.props.profileData.Patient_Data.alerts.sound_alert);
            // Spo2 alert
            local_alert_state.spo2 = AlertManager.manageFrontendAlerts(local_alert_state.spo2, this.props.profileData.Patient_Data.alerts.SPO2_alert, "SPO2_alert", this.props.profileData.Patient_Data.pulseOximeter.sp02, this.audio, this.props.profileData.Patient_Data.alerts.sound_alert);

            // 4- BANNER DISPLAY
            if (this.props.profileData.Patient_Data.pulseOximeter !== undefined){
                this.setPulseOxData(
                    PulseOximeterManager.getLastSpO2DataAndColor(this.props.profileData.Patient_Data.pulseOximeter.sp02, this.props.profileData.Patient_Data.alerts.SPO2_alert.threshold, this.props.profileData.Patient_Data.alerts.SPO2_alert.threshold2),
                    PulseOximeterManager.getLastPulseRateDataAndColor(this.props.profileData.Patient_Data.pulseOximeter.pulseRate, this.props.profileData.Patient_Data.alerts.PR_alert.threshold, this.props.profileData.Patient_Data.alerts.PR_alert.threshold2),
                    Utils.setLastMeasurementTimer(this.props.profileData.Patient_Data.pulseOximeter.pulseRate)
                );           
            }
            // Time related data ti be updated at each cycle (must be here to allow real time date change)
            this.props.profileData.Patient_Data.MaxPulseRateDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profileData.Patient_Data.alerts.PR_alert.threshold);
            this.props.profileData.Patient_Data.MinSpO2Drawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profileData.Patient_Data.alerts.SPO2_alert.threshold);
        }
        // ***************************************************************************************************************************************************************************//


        // ******************************************************************//
        // *************************** TENSIOMETER***************************//
        // ******************************************************************//  
        if ((this.props.profileData.Patient_Data.devices.device3.id !== 'dissociate')||(fullLoad)){

            // 1- GET DATA
            let bloodpressure_data_request = Utils.filterData(all_data_request, "8460-6")

            // 2- FORMAT & MERGE DATA WHEN FULLLOAD OR SAME DAY
            if ( (fullLoad) || (Utils.isSameDay(current_Date, selectedDateEnd)) ) {
                this.props.profileData.Patient_Data.pulseTensiometer    = TensionManager.formatAndMergeTensiometerData(fullLoad, this.props.profileData.Patient_Data.pulseTensiometer, bloodpressure_data_request);                    // Update tensiometer graph
            }
            bloodpressure_data_request = null;

            // 3- ALERT CHECKING
            // check pulse rate alert
            local_alert_state.pulseRateTension = AlertManager.manageFrontendAlerts(local_alert_state.pulseRateTension, this.props.profileData.Patient_Data.alerts.bloodpressure_PR_alert, "bloodpressure_PR_alert", this.props.profileData.Patient_Data.pulseTensiometer.pulseRate, this.audio, this.props.profileData.Patient_Data.alerts.sound_alert);
            // check systolic high tension alert
            local_alert_state.bloodpressure_sys_high = AlertManager.manageFrontendAlerts(local_alert_state.bloodpressure_sys_high, this.props.profileData.Patient_Data.alerts.bloodpressure_sys_high_alert, "bloodpressure_systolic_alert", this.props.profileData.Patient_Data.pulseTensiometer.systolic, this.audio, this.props.profileData.Patient_Data.alerts.sound_alert);
            // check diastolic high tension alert
            local_alert_state.bloodpressure_dia = AlertManager.manageFrontendAlerts(local_alert_state.bloodpressure_sys_high, this.props.profileData.Patient_Data.alerts.bloodpressure_dia_alert, "bloodpressure_diastolic_alert", this.props.profileData.Patient_Data.pulseTensiometer.diastolic, this.audio, this.props.profileData.Patient_Data.alerts.sound_alert);
            
            // 4- BANNER DISPLAY
            if (this.props.profileData.Patient_Data.pulseTensiometer !== undefined){
                this.setTensiometerData(
                    TensionManager.getLastTensionDataAndColor(this.props.profileData.Patient_Data.pulseTensiometer, this.props.profileData.Patient_Data.alerts.bloodpressure_sys_high_alert.threshold, this.props.profileData.Patient_Data.alerts.bloodpressure_sys_high_alert.threshold2, this.props.profileData.Patient_Data.alerts.bloodpressure_dia_alert.threshold, this.props.profileData.Patient_Data.alerts.bloodpressure_dia_alert.threshold2),
                    TensionManager.getLastPulseRateDataAndColor( this.props.profileData.Patient_Data.pulseTensiometer.pulseRate, this.props.profileData.Patient_Data.alerts.bloodpressure_PR_alert.threshold, this.props.profileData.Patient_Data.alerts.bloodpressure_PR_alert.threshold2),
                    Utils.setLastMeasurementTimer(this.props.profileData.Patient_Data.pulseTensiometer.pulseRate)
                );
            }
            // update alert curve with time (must be here to allow real time date change)        
            this.props.profileData.Patient_Data.MaxPulseRateDrawingTension =  Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profileData.Patient_Data.alerts.bloodpressure_PR_alert.threshold);
            this.props.profileData.Patient_Data.MaxSystolicDrawingTension =   Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profileData.Patient_Data.alerts.bloodpressure_sys_high_alert.threshold);
            this.props.profileData.Patient_Data.MaxDiastolicDrawingTension =  Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profileData.Patient_Data.alerts.bloodpressure_dia_alert.threshold);
        }
        // ***************************************************************************************************************************************************************************//
        


        // *******************************************************************//
        // ***************************** SCALE *******************************//
        // *******************************************************************//
        if ((this.props.profileData.Patient_Data.devices.device4.id !== 'dissociate')||(fullLoad)){
                
            // 1- GET DATA
            let scale_data_request = Utils.filterData(all_data_request, "29463-7")
            scale_data_request = Utils.filterScaleData(scale_data_request)

            // 2- FORMAT & MERGE DATA WHEN FULLLOAD OR SAME DAY
            if ( (fullLoad) || (Utils.isSameDay(current_Date, selectedDateEnd)) ) {
                this.props.profileData.Patient_Data.scale_data    = ScaleManager.formatAndMergeScaleData(fullLoad, this.props.profileData.Patient_Data.scale_data, scale_data_request);
                }
            scale_data_request = null;

            // 3- ALERT CHECKING
            local_alert_state.weight = AlertManager.manageFrontendAlerts(local_alert_state.weight, this.props.profileData.Patient_Data.alerts.weight_alert, "weight_alert", this.props.profileData.Patient_Data.scale_data.weight, this.audio, this.props.profileData.Patient_Data.alerts.sound_alert);

            // 4- BANNER DISPLAY      
            if (this.props.profileData.Patient_Data.scale_data !== undefined){
                this.setScaleDataState(
                    ScaleManager.getLastWeightDataAndColor(this.props.profileData.Patient_Data.scale_data.weight, this.props.profileData.Patient_Data.alerts.weight_alert.threshold, this.props.profileData.Patient_Data.alerts.weight_alert.threshold2),
                    Utils.setLastMeasurementTimer(this.props.profileData.Patient_Data.scale_data.weight)
                );  
            }       
            // update alert curve with time (must be here to allow real time date change)
            this.props.profileData.Patient_Data.weightThreshold =             Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profileData.Patient_Data.alerts.weight_alert.threshold);
        }
    
        // ***************************************************************************************************************************************************************************//



        // ******************************************************************//
        // ***************************   PAIN    ****************************//
        // ******************************************************************//
        if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("pain"))) {

            // 1- GET DATA
            let pain_data_request = Utils.filterData(all_data_request, "72514-3")

            // 2- FORMAT & MERGE DATA WHEN FULLLOAD OR SAME DAY
            if ( (fullLoad) || (Utils.isSameDay(current_Date, selectedDateEnd)) ) {
                this.props.profileData.Patient_Data.pain    = PainManager.formatAndMergePainData(this.props.profileData.Patient_Data.pain, pain_data_request);
            }
            pain_data_request = null;

            // 3- ALERT CHECKING
            local_alert_state.pain = AlertManager.manageFrontendAlerts(local_alert_state.pain, this.props.profileData.Patient_Data.alerts.pain_alert, "pain_alert", this.props.profileData.Patient_Data.pain, this.audio, this.props.profileData.Patient_Data.alerts.sound_alert);

            // 4- BANNER DISPLAY   TMP : nothing to display for now
            //let localPainTimerDisplay = Utils.setLastMeasurementTimer(this.props.profileData.Patient_Data.pain);
            //this.setPainDataState(...) // to do
            //localPainTimerDisplay = null;

            // update alert curve with time (must be here to allow real time date change)
            this.props.profileData.Patient_Data.MaxPainDrawing =              Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profileData.Patient_Data.alerts.pain_alert.threshold);

        }
        // ***************************************************************************************************************************************************************************//



        // *******************************************************************//
        // ****************************** EQ5D *******************************//
        // *******************************************************************//
        if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_EQ5D"))) {

            // 1- GET DATA
            let healthform_data_request = Utils.filterData(all_data_request, "45698-1")
            healthform_data_request = Utils.filterHealthform(healthform_data_request, "EQ5D5L")
                       
            // 2- FORMAT & MERGE DATA WHEN FULLLOAD OR SAME DAY
            if ( (fullLoad) || (Utils.isSameDay(current_Date, selectedDateEnd)) ) {
                this.props.profileData.Patient_Data.eq5d = HealthFormManager.formatAndMergeEQ5DData(this.props.profileData.Patient_Data.eq5d, healthform_data_request);
            }
            healthform_data_request = null;
            
            // 3- ALERT CHECKING
            // check eq5d alert
            local_alert_state.eq5d = AlertManager.manageFrontendAlerts(local_alert_state.eq5d, this.props.profileData.Patient_Data.alerts.eq5d_alert, "eq5d_alert", this.props.profileData.Patient_Data.eq5d.form_res, this.audio, this.props.profileData.Patient_Data.alerts.sound_alert);
            // check eq5d_scale alert
            local_alert_state.eq5d_scale = AlertManager.manageFrontendAlerts(local_alert_state.eq5d_scale, this.props.profileData.Patient_Data.alerts.eq5d_scale_alert, "eq5d_scale_alert", this.props.profileData.Patient_Data.eq5d.healthscale, this.audio, this.props.profileData.Patient_Data.alerts.sound_alert);

            // 4- BANNER DISPLAY
            if (this.props.profileData.Patient_Data.eq5d !== undefined){
                this.setHealthformEQ5DData(
                    HealthFormManager.getLastFormResDataAndColor(this.props.profileData.Patient_Data.eq5d.form_res, this.props.profileData.Patient_Data.alerts.eq5d_alert.threshold, 100),
                    HealthFormManager.getLastHealthscaleDataAndColor(this.props.profileData.Patient_Data.eq5d.healthscale, this.props.profileData.Patient_Data.alerts.eq5d_scale_alert.threshold, 1000),
                    Utils.setLastMeasurementTimer(this.props.profileData.Patient_Data.eq5d.healthscale)
                );             
            }
            // update alert curve with time (must be here to allow real time date change)
            this.props.profileData.Patient_Data.MaxHealthformDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profileData.Patient_Data.alerts.eq5d_alert.threshold);
            this.props.profileData.Patient_Data.MaxHealthscaleDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profileData.Patient_Data.alerts.eq5d_scale_alert.threshold);
        }
        // ***************************************************************************************************************************************************************************//



        // *******************************************************************//
        // ****************************** SF36 *******************************//
        // *******************************************************************//
        if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_SF36"))) {

            // 1- GET DATA
            let healthform_data_request = Utils.filterData(all_data_request, "45698-1")
            healthform_data_request = Utils.filterHealthform(healthform_data_request, "SF36")

            // 2- FORMAT & MERGE DATA WHEN FULLLOAD OR SAME DAY
            if ( (fullLoad) || (Utils.isSameDay(current_Date, selectedDateEnd)) ) {
                this.props.profileData.Patient_Data.sf36 = HealthFormManager.formatAndMergeSF36Data(this.props.profileData.Patient_Data.sf36, healthform_data_request);
            }
            healthform_data_request = null;
            
            // 3- ALERT CHECKING
            local_alert_state.sf36 = AlertManager.manageFrontendAlerts(local_alert_state.sf36, this.props.profileData.Patient_Data.alerts.sf36_alert, "sf36_alert", this.props.profileData.Patient_Data.sf36.form_res, this.audio, this.props.profileData.Patient_Data.alerts.sound_alert);

            // 4- BANNER DISPLAY
            if (this.props.profileData.Patient_Data.sf36 !== undefined){
                this.setHealthformSF36Data(
                    HealthFormManager.getLastFormResDataAndColor(this.props.profileData.Patient_Data.sf36.form_res, this.props.profileData.Patient_Data.alerts.sf36_alert.threshold, 100),
                    Utils.setLastMeasurementTimer(this.props.profileData.Patient_Data.sf36.form_res)
                );
            }
            // update alert curve with time (must be here to allow real time date change)
            this.props.profileData.Patient_Data.MaxHealthformDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profileData.Patient_Data.alerts.sf36_alert.threshold);
        }
        // ***************************************************************************************************************************************************************************//



        // *******************************************************************//
        // ****************************** MDASI ******************************//
        // *******************************************************************//
        if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_MDASI"))) {

            // 1- GET DATA
            let healthform_data_request = Utils.filterData(all_data_request, "45698-1")
            healthform_data_request = Utils.filterHealthform(healthform_data_request, "MDASI")

            // 2- FORMAT & MERGE DATA WHEN FULLLOAD OR SAME DAY
            if ( (fullLoad) || (Utils.isSameDay(current_Date, selectedDateEnd)) ) {
                this.props.profileData.Patient_Data.mdasi = HealthFormManager.formatAndMergeMDASIData(this.props.profileData.Patient_Data.mdasi, healthform_data_request);
            }
            healthform_data_request = null;
            
            // 3- ALERT CHECKING
            local_alert_state.mdasi = AlertManager.manageFrontendAlerts(local_alert_state.mdasi, this.props.profileData.Patient_Data.alerts.mdasi_alert, "mdasi_alert", this.props.profileData.Patient_Data.mdasi.form_res, this.audio, this.props.profileData.Patient_Data.alerts.sound_alert);

            // 4- BANNER DISPLAY
            if (this.props.profileData.Patient_Data.mdasi !== undefined){
                this.setHealthformMDASIData(
                    HealthFormManager.getLastMDASIFormResDataAndColor(this.props.profileData.Patient_Data.mdasi.form_res, this.props.profileData.Patient_Data.alerts.mdasi_alert.threshold, 0),
                    Utils.setLastMeasurementTimer(this.props.profileData.Patient_Data.mdasi.form_res)
                );
            }
            // update alert curve with time (must be here to allow real time date change)
        }
        // ***************************************************************************************************************************************************************************//



        // *******************************************************************//
        // ****************** HEALTHFORM ALIMENTATION ************************//
        // *******************************************************************//
        if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_ALIMENTATION"))) {

            // 1- GET DATA
            let healthform_data_request = Utils.filterData(all_data_request, "45698-1")
            healthform_data_request = Utils.filterHealthform(healthform_data_request, "ALIMENTATION")

            // 2- FORMAT & MERGE DATA WHEN FULLLOAD OR SAME DAY
            if ( (fullLoad) || (Utils.isSameDay(current_Date, selectedDateEnd)) ) {
                this.props.profileData.Patient_Data.alimentation = HealthFormManager.formatAndMergeAlimentationData(this.props.profileData.Patient_Data.alimentation, healthform_data_request);
            }
            healthform_data_request = null;
            
            // 3- ALERT CHECKING
            // alimentation has no alert
            
            // 4- BANNER DISPLAY
            if (this.props.profileData.Patient_Data.alimentation !== undefined){
                this.setHealthformAlimentationData(
                    HealthFormManager.getLastAlimentationFormResDataAndColor(this.props.profileData.Patient_Data.alimentation.form_res),
                    Utils.setLastMeasurementTimer(this.props.profileData.Patient_Data.alimentation.form_res)
                );
            }
        }



        // *******************************************************************//
        // ************************* RESPIRATION *****************************//
        // *******************************************************************//
        if ((Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("niv")))
         || (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("oxigen_therapy")))) { 

            // 1- GET DATA
            let nvi_schedule_data_request = Utils.filterData(all_data_request, "69988-4");
            let oxi_schedule_data_request = Utils.filterData(all_data_request, "LP75328-2");
            let respiratory_rate_data_request = Utils.filterData(all_data_request, "9279-1");
            let respiratory_leak_data_request = Utils.filterData(all_data_request, "33456-5");
            let oxygen_flow_rate_data_request = Utils.filterData(all_data_request, "3151-8");
            let respiratory_ahi_data_request = Utils.filterData(all_data_request, "90562-0");
            let respiratory_leak95_data_request = Utils.filterData(all_data_request, "33456-95");

            // 2- FORMAT & MERGE DATA WHEN FULLOAD OR SAME DAY
            if ( (fullLoad) || (Utils.isSameDay(current_Date, selectedDateEnd)) ) {
                //TMP: should be same function called 3 times (for each data type) => formatAndMergeBreathingCurve
                //TMP: should also have function called for schedules => formatAndMergeBreathingSchedule
                this.props.profileData.Patient_Data.breathing = BreathingManager.formatAndMergeBreathingData(this.props.profileData.Patient_Data.breathing, nvi_schedule_data_request, oxi_schedule_data_request, respiratory_rate_data_request, respiratory_leak_data_request, oxygen_flow_rate_data_request, selectedDateEnd, this.state.lastBreathingUsageDataDate, respiratory_ahi_data_request, respiratory_leak95_data_request);
            }
            if (selectedDateEnd.getTime() >= this.state.lastBreathingUsageDataDate) {
                this.setState({
                    lastBreathingUsageDataDate: selectedDateEnd.getTime()
                })
            }
            nvi_schedule_data_request = null;
            oxi_schedule_data_request = null;
            
            // 3- ALERT CHECKING
            // check breathing alerts
            //local_alert_state.breathing_rate = AlertManager.manageFrontendAlerts(local_alert_state.breathing_rate, this.props.profileData.Patient_Data.alerts.breathing_rate_alert, "breathing_rate_alert", this.props.profileData.Patient_Data.breathing.respiratory_rate, this.audio, this.props.profileData.Patient_Data.alerts.sound_alert);
            //local_alert_state.breathing_oxygen_rate = AlertManager.manageFrontendAlerts(local_alert_state.breathing_oxygen_rate, this.props.profileData.Patient_Data.alerts.breathing_oxygen_rate_alert, "breathing_oxygen_rate_alert", this.props.profileData.Patient_Data.breathing.oxygen_flow_rate, this.audio, this.props.profileData.Patient_Data.alerts.sound_alert);
            //local_alert_state.breathing_leakage = AlertManager.manageFrontendAlerts(local_alert_state.breathing_leakage, this.props.profileData.Patient_Data.alerts.breathing_leakage_alert, "breathing_leakage_alert", this.props.profileData.Patient_Data.breathing.respiratory_leak, this.audio, this.props.profileData.Patient_Data.alerts.sound_alert);

            // 4- BANNER DISPLAY
            if (this.props.profileData.Patient_Data.breathing !== undefined){
                this.setHealthformNviData(
                    BreathingManager.getLastBreathingUsageDataAndColor(this.props.profileData.Patient_Data.breathing.niv_usage, selectedDateStart, selectedDateEnd),
                    BreathingManager.getLastBreathingLeakDataAndColor(this.props.profileData.Patient_Data.breathing.respiratory_leak, this.props.profileData.Patient_Data.alerts.breathing_leakage_alert.threshold, -100),
                    BreathingManager.getLastBreathingRateDataAndColor(this.props.profileData.Patient_Data.breathing.respiratory_rate, this.props.profileData.Patient_Data.alerts.breathing_rate_alert.threshold, this.props.profileData.Patient_Data.alerts.breathing_rate_alert.threshold2),
                    BreathingManager.getLastBreathingAhiDataAndColor(this.props.profileData.Patient_Data.breathing.respiratory_ahi, (this.props.profileData.Patient_Data.alerts.breathing_ahi_alert || {}).threshold || 15),
                    Utils.setLastMeasurementTimer(this.props.profileData.Patient_Data.breathing.respiratory_rate)
                );
                this.setHealthformOxiData(
                    BreathingManager.getLastBreathingUsageDataAndColor(this.props.profileData.Patient_Data.breathing.oxi_usage, new Date(this.props.dateSelected[0]), new Date(this.props.dateSelected[1])),
                    BreathingManager.getLastBreathingOxygenRateDataAndColor(this.props.profileData.Patient_Data.breathing.oxygen_flow_rate, this.props.profileData.Patient_Data.alerts.breathing_leakage_alert.threshold, -100),
                    Utils.setLastMeasurementTimer(this.props.profileData.Patient_Data.breathing.oxygen_flow_rate)
                );
            }
            // update alert curve with time (must be here to allow real time date change)
            this.props.profileData.Patient_Data.MaxBreathingRateDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profileData.Patient_Data.alerts.breathing_rate_alert.threshold);
            this.props.profileData.Patient_Data.MaxBreathingOxygenRateDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profileData.Patient_Data.alerts.breathing_oxygen_rate_alert.threshold);
            this.props.profileData.Patient_Data.MaxBreathingLeakageDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profileData.Patient_Data.alerts.breathing_leakage_alert.threshold);
            this.props.profileData.Patient_Data.MaxBreathingObservanceDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, this.props.profileData.Patient_Data.alerts.breathing_observance_alert.threshold);
            this.props.profileData.Patient_Data.MaxBreathingAhiDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, (this.props.profileData.Patient_Data.alerts.breathing_ahi_alert || {}).threshold || 15);
            this.props.profileData.Patient_Data.MaxBreathingAhiObjectiveDrawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, 10);
            this.props.profileData.Patient_Data.MaxBreathingLeak95Drawing = Utils.setAlertCurve(selectedDateStart, selectedDateEnd, (this.props.profileData.Patient_Data.alerts.breathing_leakage95_alert || {}).threshold || 24);
        }





        
        // ***************************************************************************************************************************************************************************//



        // *******************************************************************//
        // ************************ PHOTOGRAPHY ******************************//
        // *******************************************************************//
        if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("picture"))) {
            // 1- GET DATA
            let photography_data_request = Utils.filterData(all_data_request, "72170-4")

            // 2- FORMAT & MERGE DATA WHEN FULLLOAD OR SAME DAY
            if ( (fullLoad) || (Utils.isSameDay(current_Date, selectedDateEnd)) ) {
                this.props.profileData.Patient_Data.photo = PhotographyDataManager.formatAndMergePhotographyData(this.props.profileData.Patient_Data.photo, photography_data_request);
            }
            photography_data_request = null;
        }
            
        // ***************************************************************************************************************************************************************************//

        // *******************************************************************//
        // ************************ KIDNEY DEVICE & BLOOD ********************//
        // *******************************************************************//
        if (Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("kidney_failure"))
            && ( fullLoad || Utils.isSameDay(current_Date, selectedDateEnd))) {
          const healthform_data_request = Utils.filterData(all_data_request, "45698-1");

          let kidney_data_request = Utils.filterHealthform(healthform_data_request, "kidney_device");
          this.props.profileData.Patient_Data.kidney_device = HealthFormManager.formatAndMergeKidneyDeviceData(this.props.profileData.Patient_Data.kidney_device, kidney_data_request);

          kidney_data_request = Utils.filterHealthform(healthform_data_request, "kidney_blood");
          this.props.profileData.Patient_Data.kidney_blood = HealthFormManager.formatAndMergeKidneyBloodData(this.props.profileData.Patient_Data.kidney_blood, kidney_data_request);
        }


        // ******************** CURRENT TIME GRAPH UPDATE ************************//
        this.props.profileData.Patient_Data.currentTime = Utils.setCurrentTimePoint(selectedDateEnd);
        this.setState({
            frontend_alert_state : local_alert_state
        })
        local_alert_state = null;

        // ******************** DEFAULT TAB SELECTION ***************************//
        // Once data is loaded, land on the first parameter tab (temperature by default)
        // that actually carries data; if temperature has none, fall through to the next
        // one that does. Done only on the first full load and never over a manual switch.
        if (fullLoad && !this.defaultTabApplied) {
            this.defaultTabApplied = true;
            let defaultTab = Utils.getFirstTabWithData(this.props.subscription_info.features, this.props.profileData.Patient_Data);
            if (defaultTab !== this.state.activeTab) {
                this.setState({ activeTab: defaultTab });
            }
        }
    }





    //Function updating Tucky variable states with new values
    setTuckyData (localTemperatureDisplay, localMaxTemperatureLast3h, lastbatteryAndPosition, timer){

       this.setState({
            temperatureDisplay: localTemperatureDisplay, 
            maxTemperatureLast3h: localMaxTemperatureLast3h,
            batteryLevelDisplay: lastbatteryAndPosition.battery,
            positionDisplay: lastbatteryAndPosition.position,
            temperatureTimerDisplay: timer
        })
    }

    //Function updating PulseOx variable states with new values
    setPulseOxData (spo2Display, pulseRateDisplay, timer){

        this.setState({
            spo2Display: spo2Display,
            pulseRateDisplay: pulseRateDisplay,
            spo2PrTimerDisplay: timer            
        })
    }

    //Function updating tensiometer variable states with new values
    setTensiometerData (tensionDisplay, pulseRateDisplayTensiometer, timer){

        this.setState({
            tensionDisplay: tensionDisplay,
            pulseRateDisplayTensiometer: pulseRateDisplayTensiometer,
            tensionTimerDisplay: timer
            })
        }

    //Function updating sclae states with new values
    setScaleDataState (localWeightDisplay, timer){

        this.setState({
            weightDisplay: localWeightDisplay,
            weightTimerDisplay: timer
            })
        }

    //Function updating form variable states with new values
    setHealthformEQ5DData (formresDisplay, healthscaleDisplay, timer){

        this.setState({
            formresDisplay: formresDisplay,
            healthscaleDisplay: healthscaleDisplay,
            formTimerDisplay: timer
            })
        }


    //Function updating form variable states with new values
    setHealthformSF36Data (formresSF36Display, timer){

        this.setState({
            formresSF36Display: formresSF36Display,
            formSF36TimerDisplay: timer
            })
        }


    //Function updating form variable states with new values
    setHealthformMDASIData (formresMDASIDisplay, timer){

        this.setState({
            formresMDASIDisplay: formresMDASIDisplay,
            formMDASITimerDisplay: timer
            })
        }


    //Function updating form variable states with new values
    setHealthformAlimentationData (formresAlimentationDisplay, timer){

        this.setState({
            formresAlimentationDisplay: formresAlimentationDisplay,
            formAlimentationTimerDisplay: timer
            })
        }


    //Function updating form variable states with new values
    setHealthformNviData (breathingUsageNivDisplay, breathingLeakNivDisplay, breathingRateNivDisplay, ahiIndexDisplay, timer){

        this.setState({
            breathingUsageNivDisplay: breathingUsageNivDisplay,
            breathingLeakNivDisplay: breathingLeakNivDisplay,
            breathingRateNivDisplay: breathingRateNivDisplay,
            ahiIndexDisplay: ahiIndexDisplay,
            formNivTimerDisplay: timer
            })
        }


    //Function updating form variable states with new values
    setHealthformOxiData (formresBreathingDisplay, formresOxiBreathingRateDisplay, timer){

        this.setState({
            formresOxiUsageDisplay: formresBreathingDisplay,
            formresOxiBreathingRateDisplay: formresOxiBreathingRateDisplay,
            formOxiTimerDisplay: timer
        })
    }


    //Function to calculate profile width for reponsive display
    getProfileWidth(){

        let profile_width = "400px";
        let screen_width = window.innerWidth;
        let ratio_screen_minwidth = screen_width / 400;
        let margin_for_row_multiple_profile = 20;

        if(ratio_screen_minwidth < 2) {
            profile_width = screen_width - 10;
        }
        else{

            let decimal = ratio_screen_minwidth - Math.floor(ratio_screen_minwidth)

            if(decimal <= 0.5){
                profile_width = (screen_width - margin_for_row_multiple_profile) / Math.floor(ratio_screen_minwidth);
            }
            else{
                profile_width = (screen_width - margin_for_row_multiple_profile) / Math.ceil(ratio_screen_minwidth);
            }
        }

        return (profile_width.toString() + "px")
    }

    //Function to return main box style
    getCardIdAlert(){

        let card_id_alert = "main-box";

        if((this.state.frontend_alert_state.position.triggered)
            ||(this.state.frontend_alert_state.fever.triggered)
            ||(this.state.frontend_alert_state.detach.triggered)
            ||(this.state.frontend_alert_state.battery.triggered)            
            ||(this.state.frontend_alert_state.pulseRate.triggered)
            ||(this.state.frontend_alert_state.spo2.triggered)
            ||(this.state.frontend_alert_state.pulseRateTension.triggered)
            ||(this.state.frontend_alert_state.bloodpressure_sys_high.triggered)
            ||(this.state.frontend_alert_state.reminder.triggered)
            ||(this.state.frontend_alert_state.weight.triggered)            
            ||(this.state.frontend_alert_state.eq5d.triggered)
            ||(this.state.frontend_alert_state.eq5d_scale.triggered)
            ||(this.state.frontend_alert_state.sf36.triggered)
            ||(this.state.frontend_alert_state.mdasi.triggered)
            ||(this.state.frontend_alert_state.pain.triggered)
            ||(this.state.frontend_alert_state.breathing_rate.triggered)
            ||(this.state.frontend_alert_state.breathing_oxygen_rate.triggered)
            ||(this.state.frontend_alert_state.breathing_leakage.triggered)
        ){
            card_id_alert = "main-box-alert";
        }

        return (card_id_alert);
    }


    //Function to display right design for cards depending on monitoring activation
    getCardIdMonitoring(){

        let card_id_monitoring = "box-one";

        if(this.props.profileData.Patient_Data.monitoring_activation === "no"){
           card_id_monitoring = "box-one-nomonitoring" 
        }

        return(card_id_monitoring)
    }


    //Function to display right design for tabs depending on monitoring activation
    getTabDisplay(){

        let tab_id_monitoring = "tab-follow";

        if(this.props.profileData.Patient_Data.monitoring_activation === "no"){
           tab_id_monitoring = "tab-unfollow"
        }

        return(tab_id_monitoring)

    }

    //Function to get background color for row containing tabs
    getTabRowColor(){

        let paramTabColor = "#30677F";

        if(this.props.profileData.Patient_Data.monitoring_activation === "no"){
           paramTabColor = "#3A5774";
        }

        return(paramTabColor)
    }





    //Function to change the color of the pain scale
    getPainColor() {
        let ret = "#548BF4"
        if (this.state.painLevel == 0)
        {
            ret = "#548BF4"
        }
        else if (this.state.painLevel > 0 && this.state.painLevel < 4)
        {
            ret = "#93be2f"
        }
        else if (this.state.painLevel > 3 && this.state.painLevel < 6)
        {
            ret = "#f3f322"
        }
        else if (this.state.painLevel > 5 && this.state.painLevel < 8)
        {
            ret = "#ff7f00"
        }
        else
        {
            ret = "#d20100"
        }
        return (ret)
    }

    movePainLevel(values){
        this.setState({painLevel: values})
        if (this.state.painLevelChanged === false) {
            this.setState({painLevelChanged: true})
        }
    }


    photoUpdate = (current_Date, new_value) => {

        let new_value_object = [{
            eventDate: current_Date,
            value: new_value
        }]

        let updated_photography_data = PhotographyDataManager.formatAndMergePhotographyData(this.props.profileData.Patient_Data.photo, new_value_object)
        // Update carousel with photography data
        this.props.profileData.Patient_Data.photo = updated_photography_data;

        // To make sure the local carousel autoupdates
        this.setState({
        })
    
        updated_photography_data = null
        return (true)
    }

    healthformEQ5DUpdate = async (current_Date, new_value, frontend_alert_state) => {    // use for real time display of new form results

        let new_value_stringified = [{
            eventDate: current_Date,
            value: JSON.stringify(new_value)
        }]

        let updated_healthform_data = HealthFormManager.formatAndMergeEQ5DData(this.props.profileData.Patient_Data.eq5d, new_value_stringified);
        // Update graph with healthform data
        this.props.profileData.Patient_Data.eq5d = updated_healthform_data;

        // Update banner
        let localFormResDisplay = HealthFormManager.getLastFormResDataAndColor(updated_healthform_data.form_res, this.props.profileData.Patient_Data.alerts.eq5d_alert.threshold, 100);
        let localHealthscaleDisplay = HealthFormManager.getLastHealthscaleDataAndColor(updated_healthform_data.healthscale, this.props.profileData.Patient_Data.alerts.eq5d_scale_alert.threshold, 1000);
        let localFormTimerDisplay = Utils.setLastMeasurementTimer(updated_healthform_data.form_res);

        this.setState({
            frontend_alert_state: this.state.frontend_alert_state,
            formresDisplay: localFormResDisplay,
            healthscaleDisplay: localHealthscaleDisplay,
            formTimerDisplay: localFormTimerDisplay
        })
    
        updated_healthform_data = null
        return (true)
    }

    healthformSF36Update = async (current_Date, new_value, frontend_alert_state) => {    // use for real time display of new form results

        let new_value_stringified = [{
            eventDate: current_Date,
            value: JSON.stringify(new_value)
        }]

        let updated_healthform_data = HealthFormManager.formatAndMergeSF36Data(this.props.profileData.Patient_Data.sf36, new_value_stringified);
        // Update graph with healthform data
        this.props.profileData.Patient_Data.sf36 = updated_healthform_data;

        // Update banner
        let localFormResDisplay = HealthFormManager.getLastAlimentationFormResDataAndColor(updated_healthform_data.form_res, this.props.profileData.Patient_Data.alerts.sf36_alert.threshold, 100);
        let localFormTimerDisplay = Utils.setLastMeasurementTimer(updated_healthform_data.form_res);

        this.setState({
            frontend_alert_state: this.state.frontend_alert_state,
            formresSF36Display: localFormResDisplay,
            formSF36TimerDisplay: localFormTimerDisplay
        })
    
        updated_healthform_data = null
        return (true)
    }

    healthformMDASIUpdate = async (current_Date, new_value, frontend_alert_state) => {    // use for real time display of new form results

        let new_value_stringified = [{
            eventDate: current_Date,
            value: JSON.stringify(new_value)
        }]

        let updated_healthform_data = HealthFormManager.formatAndMergeMDASIData(this.props.profileData.Patient_Data.mdasi, new_value_stringified);
        // Update graph with healthform data
        this.props.profileData.Patient_Data.mdasi = updated_healthform_data;

        // Update banner
        let localFormResDisplay = HealthFormManager.getLastAlimentationFormResDataAndColor(updated_healthform_data.form_res, this.props.profileData.Patient_Data.alerts.mdasi_alert.threshold, 100);
        let localFormTimerDisplay = Utils.setLastMeasurementTimer(updated_healthform_data.form_res);

        this.setState({
            frontend_alert_state: this.state.frontend_alert_state,
            formresMDASIDisplay: localFormResDisplay,
            formMDASITimerDisplay: localFormTimerDisplay
        })
    
        updated_healthform_data = null
        return (true)
    }

    healthformAlimentationUpdate = async (current_Date, new_value, frontend_alert_state) => {    // use for real time display of new form results

        let new_value_stringified = [{
            eventDate: current_Date,
            value: JSON.stringify(new_value)
        }]

        let updated_healthform_data = HealthFormManager.formatAndMergeAlimentationData(this.props.profileData.Patient_Data.alimentation, new_value_stringified);
        // Update graph with healthform data
        this.props.profileData.Patient_Data.alimentation = updated_healthform_data;

        // Update banner
        let localFormResDisplay = HealthFormManager.getLastAlimentationFormResDataAndColor(updated_healthform_data.form_res);
        let localFormTimerDisplay = Utils.setLastMeasurementTimer(updated_healthform_data.form_res);

        this.setState({
            formresAlimentationDisplay: localFormResDisplay,
            formAlimentationTimerDisplay: localFormTimerDisplay
        })
    
        updated_healthform_data = null
        return (true)
    }

    breathingUpdate = async (current_Date, new_value, frontend_alert_state) => {    // use for real time display of both niv and oxy data (which are stored in same healthform like structure)

        let respiratoryrate_index = new_value.findIndex((n) => n.label === "respiratory_rate")
        let new_respiratoryrate = []
        if (respiratoryrate_index !== -1) {
            if (new_value[respiratoryrate_index].value !== "0") {
            new_respiratoryrate = [{
            eventDate: current_Date,
            value: new_value[respiratoryrate_index].value
        }]
        }
        }

        let new_respiratoryleak = []
        let respiratoryleak_index = new_value.findIndex((n) => n.label === "respiratory_leak")
        if (respiratoryleak_index !== -1) {
            if (new_value[respiratoryleak_index].value !== "0") {
            new_respiratoryleak = [{
            eventDate: current_Date,
            value: new_value[respiratoryleak_index].value
        }]
        }
        }

        let new_oxigenflowrate = []
        let oxigenflowrate_index = new_value.findIndex((n) => n.label === "oxigen_flow_rate")
        if (oxigenflowrate_index !== -1) {
            new_oxigenflowrate = [{
            eventDate: current_Date,
            value: new_value[oxigenflowrate_index].value
        }]
        }

        delete new_value.respiratory_rate
        delete new_value.respiratory_leak
        delete new_value.oxygen_flow_rate
        let newVNIData = []
        let VNI_index = new_value.findIndex((n) => n.label === "niv_schedule")
        if (VNI_index !== -1) {
            newVNIData = [{
            eventDate: current_Date,
                value: new_value[VNI_index].value
        }]
        }

        let newOxiData = []
        let oxi_index = new_value.findIndex((n) => n.label === "oxi_schedule")
        if (oxi_index !== -1) {
            newOxiData = [{
                eventDate: current_Date,
                value: new_value[oxi_index].value
            }]
        }

        let updated_breathing_data = BreathingManager.formatAndMergeBreathingData(this.props.profileData.Patient_Data.breathing, newVNIData, newOxiData, new_respiratoryrate, new_respiratoryleak, new_oxigenflowrate, this.props.dateSelected[1], this.state.lastBreathingUsageDataDate);
        // Update graph with data
        this.props.profileData.Patient_Data.breathing = updated_breathing_data;

        // Update banner
        let localFormResDisplay = BreathingManager.getLastBreathingFormResDataAndColor(updated_breathing_data.form_res, this.props.profileData.Patient_Data.alerts.breathing_rate_alert.threshold, 100);
        let localFormTimerDisplay = Utils.setLastMeasurementTimer(updated_breathing_data.form_res);

        this.setState({
            frontend_alert_state: this.state.frontend_alert_state,
            formresBreathingDisplay: localFormResDisplay,
            formBreathingTimerDisplay: localFormTimerDisplay
        })
    
        this.setHealthformNviData(
            BreathingManager.getLastBreathingUsageDataAndColor(this.props.profileData.Patient_Data.breathing.niv_usage, new Date(this.props.dateSelected[0]), new Date(this.props.dateSelected[1])),
            BreathingManager.getLastBreathingLeakDataAndColor(this.props.profileData.Patient_Data.breathing.respiratory_leak, this.props.profileData.Patient_Data.alerts.breathing_leakage_alert.threshold, -100),
            BreathingManager.getLastBreathingRateDataAndColor(this.props.profileData.Patient_Data.breathing.respiratory_rate, this.props.profileData.Patient_Data.alerts.breathing_rate_alert.threshold, this.props.profileData.Patient_Data.alerts.breathing_rate_alert.threshold2),
            BreathingManager.getLastBreathingAhiDataAndColor(this.props.profileData.Patient_Data.breathing.respiratory_ahi, (this.props.profileData.Patient_Data.alerts.breathing_ahi_alert || {}).threshold || 15),
            Utils.setLastMeasurementTimer(this.props.profileData.Patient_Data.breathing.respiratory_rate)
        );
        this.setHealthformOxiData(
            BreathingManager.getLastBreathingUsageDataAndColor(this.props.profileData.Patient_Data.breathing.oxi_usage, new Date(this.props.dateSelected[0]), new Date(this.props.dateSelected[1])),
            BreathingManager.getLastBreathingOxygenRateDataAndColor(this.props.profileData.Patient_Data.breathing.oxygen_flow_rate, this.props.profileData.Patient_Data.alerts.breathing_leakage_alert.threshold, -100),
            Utils.setLastMeasurementTimer(this.props.profileData.Patient_Data.breathing.oxygen_flow_rate)
        );
    
        updated_breathing_data = null
        return (true)
    }

    kidneyDeviceUpdate = async (current_Date, new_value) => {
        let new_value_stringified = [{
            eventDate: current_Date,
            value: JSON.stringify(new_value)
        }]

        let updated_healthform_data = HealthFormManager.formatAndMergeKidneyDeviceData(this.props.profileData.Patient_Data.kidney_device, new_value_stringified);
        this.props.profileData.Patient_Data.kidney_device = updated_healthform_data;

        this.forceUpdate();

        updated_healthform_data = null;
        return (true)
    }
  
    kidneyBloodUpdate = async (current_Date, new_value) => {
        let new_value_stringified = [{
            eventDate: current_Date,
            value: JSON.stringify(new_value)
        }]

        let updated_healthform_data = HealthFormManager.formatAndMergeKidneyBloodData(this.props.profileData.Patient_Data.kidney_blood, new_value_stringified);
        this.props.profileData.Patient_Data.kidney_blood = updated_healthform_data;

        this.forceUpdate();

        updated_healthform_data = null;
        return (true)
    }


    sendPainLevel = async (e) => {    // use to send pain data in cloud and to display real time value in graph   // TMP :should be in future PainDisplay component

        let current_Date = new Date()        

        // send data to cloud
        let res = await PostDataController.post_observation(current_Date, this.state.painLevel[0], "pain", this.props.profileData.Patient_Data.id_patient)
        if (res === true) {
            this.setState({painLevelChanged: false})
        }

        // display data in graph
        let new_value_dated = [{
            eventDate: current_Date,
            value: JSON.stringify(this.state.painLevel[0]) 
        }]

        let updated_pain_data = PainManager.formatAndMergePainData(this.props.profileData.Patient_Data.pain, new_value_dated);
        // Update graph with healthform data

        this.props.profileData.Patient_Data.pain = updated_pain_data;

        this.setState({
        })

        updated_pain_data = null;
    }


    //Function to render pain scale
    renderPainScale() {
        if (this.props.accountInformation.readOnly !== true) {
        return(
            <div
                style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    marginLeft: "1em",
                    marginRight: "1em",
                    marginTop: "1em"
                }}
            >
            <output style={{ display: "fixed", marginRight: "20px"}} id="output">
                {this.state.painLevel}
            </output>
            <Range
              values={this.state.painLevel}
              step={1}
              min={0}
              max={10}
              onChange={(values) => this.movePainLevel(values)}
              renderTrack={({ props, children }) => (
                <div
                  onMouseDown={props.onMouseDown}
                  onTouchStart={props.onTouchStart}
                  style={{
                    ...props.style,
                    height: "36px",
                    display: "flex",
                    width: "100%"
                  }}
                >
                  <div
                    ref={props.ref}
                    style={{
                      height: "5px",
                      width: "100%",
                      borderRadius: "4px",
                      background: getTrackBackground({
                        values: this.state.painLevel,
                        colors: [this.getPainColor(), "#ccc"], //change the first to change the left part of the bar
                        min: 0,
                        max: 10
                      }),
                      alignSelf: "center"
                    }}
                  >
                    {children}
                  </div>
                </div>
              )}
              renderThumb={({ props, isDragged }) => (
                <div
                  {...props}
                  style={{
                    ...props.style,
                    height: "30px",
                    width: "30px",
                    borderRadius: "4px",
                    backgroundColor: "#FFF", //color of the button
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    boxShadow: "0px 2px 6px #AAA"
                  }}
                >
                  <div
                    style={{
                      height: "16px",
                      width: "5px",
                      backgroundColor: isDragged ? this.getPainColor() : "#CCC"
                    }}
                  />
                </div>
              )}
            />
                <b>&emsp;</b>
                <button onClick={() => {this.sendPainLevel()}} className="btn btn-success" disabled={!this.state.painLevelChanged}>
                    <FormattedMessage id="account.validationButton" defaultMessage="Submit" />
                </button>
            </div>
        )
    }
        else {
            return(null)
        }
    }


    checkINSData(){
        let ret = true
        if (this.props.profileData.Patient_Data.INS_Data.OID === undefined
            || this.props.profileData.Patient_Data.INS_Data.NomNaissance === undefined
            || this.props.profileData.Patient_Data.Prenom === undefined
            || this.props.profileData.Patient_Data.INS_Data.DateNaissance === undefined
            || this.props.profileData.Patient_Data.INS_Data.Sex === undefined
            || this.props.profileData.Patient_Data.INS_Data.LieuNaissance === undefined) {
            ret = false
        }
        return ret
    }

    display_formEQ5DGraph() {
        if (this.props.profileData.Patient_Data.eq5d.form_res.length > 0) {
            return (Utils.display_formEQ5DGraph({...this.props, onEnlarge: () => this.openGraphPopup("EQ5D")}))
    }
        else {
            return null
        }
    }
            
    display_formSF36Graph(){
        if (this.props.profileData.Patient_Data.sf36.form_res.length > 0) {
            return (Utils.display_SF36Graph(this.props))
        }
        else {
            return null
        }
    }
            
    display_kidneyDeviceTable(){
      if (this.props.profileData.Patient_Data.kidney_device.form_res.length > 0) {
        return (KidneyDisplayTables.display_kidneyDeviceTable(this.props))
      }
      else {
        return null
      }
    }
  
    display_kidneyBloodTable(){
      if (this.props.profileData.Patient_Data.kidney_blood.form_res.length > 0) {
        return (KidneyDisplayTables.display_kidneyBloodTable(this.props))
      }
      else {
        return null
      }
    }
            
    display_formMDASIGraph(){
        if (this.props.profileData.Patient_Data.mdasi.form_res.length > 0) {
            return (Utils.display_MDASIGraph(this.props))
        }
        else {
            return null
        }
    }

    display_formAlimentationGraph(){
        if (this.props.profileData.Patient_Data.alimentation.form_res.length > 0) {
            return (Utils.display_AlimentationGraph(this.props))
        }
        else {
            return null
        }
    }

    display_breathingGraphs_NIV(){
        if (Utils.testNivData(this.props.profileData.Patient_Data.breathing)) {
           
            let alertPointReminder = AlertManager.getLastAlertMax7days(this.props.profileData.Patient_Data.alerts_triggered, "reminder_alert")
            let alertPointPR = AlertManager.getLastAlertMax7days(this.props.profileData.Patient_Data.alerts_triggered, "PR_alert")
            let alertPointSP02 = AlertManager.getLastAlertMax7days(this.props.profileData.Patient_Data.alerts_triggered, "SPO2_alert")
            return(
                <div>
                    {this.props.intl.formatMessage({id: "breathing.form.title"})}
                    {Utils.display_breathingGraph_NIVUsage({...this.props, onEnlarge: () => this.openGraphPopup("NIVUsage")})}
                    {Utils.display_breathingGraph_NIVLeakage({...this.props, onEnlarge: () => this.openGraphPopup("NIVLeak")})}
                    {Utils.display_breathingGraph_NIVBreathingRate({...this.props, onEnlarge: () => this.openGraphPopup("NIVRate")})}
                    {Utils.display_breathingGraph_AHI({...this.props, onEnlarge: () => this.openGraphPopup("AHI")})}
                    {Utils.display_breathingGraph_Leak95({...this.props, onEnlarge: () => this.openGraphPopup("Leak95")})}
                    {this.props.intl.formatMessage({id: "device.oximeter.name"})}
                    {Utils.display_pulseOximeterGraph({...this.props, onEnlarge: () => this.openGraphPopup("oximeterPulseRate")}, 100)}
                </div>
            )
        }
        else {
            return null
        }
    }

    display_breathingGraphs_oxy() {
        if (Utils.testOxiData(this.props.profileData.Patient_Data.breathing)) {
            let oxygen_flow_rate_curve = this.props.profileData.Patient_Data.breathing.oxygen_flow_rate
            let alertPointOxygenRate = AlertManager.getLastAlertMax7days(this.props.profileData.Patient_Data.alerts_triggered, "breathing_oxygen_rate_alert")

            let alertPointPR = AlertManager.getLastAlertMax7days(this.props.profileData.Patient_Data.alerts_triggered, "PR_alert")
            let alertPointSP02 = AlertManager.getLastAlertMax7days(this.props.profileData.Patient_Data.alerts_triggered, "SPO2_alert")
            let alertPointReminder = AlertManager.getLastAlertMax7days(this.props.profileData.Patient_Data.alerts_triggered, "reminder_alert")
            return (
                <div>
                    {this.props.intl.formatMessage({id: "Suivi machine"})}                                  
                    {Utils.display_breathingGraph_OxiUsage({...this.props, onEnlarge: () => this.openGraphPopup("OxiUsage")})}
                    {Utils.display_breathingGraph_OxygenFlowRate({...this.props, onEnlarge: () => this.openGraphPopup("OxiRate")})}
                    {this.props.intl.formatMessage({id: "device.oximeter.name"})}
                    {Utils.display_pulseOximeterGraph({...this.props, onEnlarge: () => this.openGraphPopup("oximeterPulseRate")}, 101)}
                </div>
            )
        }
        else {
            return null
        }
    }

    displayPhotoCarousel() {
        return(
            <PhotoCarousel
                accountInformation = {this.props.accountInformation}
                photo = {this.props.profileData.Patient_Data.photo}
                currentLocale= {this.props.accountInformation.language}
                selectedPicture= {this.state.selectedPicture}
                handleCarrouselChange= {this.handleCarrouselChange}
            />
        )
    }

    // Function to display patient name, birthdate, detach alert and close alert button
    display_name_birthdate(){

        let anonymised = this.props.accountInformation.anonymised_patient

        return(
            <Row style={{width: "100%"}}>
                {anonymised ?
                    <Row id="row-fullname" style={{ display: 'flex', gap: 6 }}>
                        <span style={{ cursor: 'pointer' }} onClick={() => this.setState({ showProfileModal: true })}>{this.props.profileData.Patient_Data.id_patient}</span>
                        <Icon name="user circle" style={{ cursor: 'pointer', color: '#fff', fontSize: '1.1em' }} title="Profil patient" onClick={() => this.setState({ showProfileModal: true })} />
                    </Row>
                    :
                    <Row id="row-fullname" style={{ display: 'flex', gap: 6 }}>
                        <span style={{ cursor: 'pointer' }} onClick={() => this.setState({ showProfileModal: true })}>
                        {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("hepadom")) ?
                            this.props.profileData.Patient_Data.firstname
                            :
                            this.props.profileData.Patient_Data.firstname + " " + this.props.profileData.Patient_Data.lastname
                        }
                        </span>
                        {userIsSuperAdmin(this.props.accountInformation) && !this.props.hidePatientIds && (
                            <CopyableId value={this.props.profileData.Patient_Data.id_patient} label="id_patient" />
                        )}
                        <Icon name="user circle" style={{ cursor: 'pointer', color: '#fff', fontSize: '1.1em' }} title="Profil patient" onClick={() => this.setState({ showProfileModal: true })} />
                    </Row>
                }
                <Row id="row-birthdate-detach-alert">
                    {anonymised ?
                        <Col id="col-birthdate">
                            <br/>
                        </Col>
                        :
                    <Col id="col-birthdate">
                            {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("hepadom")) ?
                                Utils.convert_date_to_full_date_string_hepadom(this.props.profileData.Patient_Data.birthdate)
                                :
                                Utils.convert_date_to_full_date_string(this.props.profileData.Patient_Data.birthdate)
                            }
                    </Col>
                    }
                    <Col id="col-detach-alert-box-one">
                        {(this.state.frontend_alert_state.detach.triggered) ?
                            <div id="detach-alert-box">
                                <FormattedMessage id="alert.detach" defaultMessage="Tucky detached"/>
                            </div>       
                            :
                            null
                        }
                    </Col>  
                </Row>

                {((this.state.frontend_alert_state.position.triggered)
                    ||(this.state.frontend_alert_state.fever.triggered)
                    ||(this.state.frontend_alert_state.detach.triggered)
                    ||(this.state.frontend_alert_state.battery.triggered)                    
                    ||(this.state.frontend_alert_state.pulseRate.triggered)
                    ||(this.state.frontend_alert_state.spo2.triggered)
                    ||(this.state.frontend_alert_state.pulseRateTension.triggered)
                    ||(this.state.frontend_alert_state.bloodpressure_sys_high.triggered)
                    ||(this.state.frontend_alert_state.bloodpressure_dia.triggered)
                    ||(this.state.frontend_alert_state.reminder.triggered)
                    ||(this.state.frontend_alert_state.weight.triggered)
                    ||(this.state.frontend_alert_state.pain.triggered)
                    ||(this.state.frontend_alert_state.eq5d.triggered)
                    ||(this.state.frontend_alert_state.eq5d_scale.triggered)
                    ||(this.state.frontend_alert_state.sf36.triggered)
                    ||(this.state.frontend_alert_state.mdasi.triggered)
                    ||(this.state.frontend_alert_state.pain.triggered)
                    ||(this.state.frontend_alert_state.breathing_rate.triggered)
                    ||(this.state.frontend_alert_state.breathing_oxygen_rate.triggered)
                    ||(this.state.frontend_alert_state.breathing_leakage.triggered)
                    ) ?
                    <button id="close-alert-button" onClick={this.handleClick}>x</button>
                    :
                    null
                }
            </Row>
        )
    }


    // Function to display patient birthplace and tabs
    display_birthplace_tabs(){

        return(

          <Row style={{width: "100%", backgroundColor: this.getTabRowColor()}}>
                <Row style={{width: "100%", backgroundColor: this.getTabRowColor()}}>
                    <Col style={{ width:'100%', color: "white", fontStyle: 'italic', display: "flex", flexDirection: "row", justifyContent: "left", paddingLeft:'2.5%'}}>
                        {((((this.props.profileData.Patient_Data.location !== "")&&(this.props.profileData.Patient_Data.location !== undefined)) || ((this.props.profileData.Patient_Data.birthPlace !== "")&&(this.props.profileData.Patient_Data.birthPlace !== undefined))) && !this.props.accountInformation.anonymised_patient)?
                                <Row>
                                    <Icon name='map marker alternate' inverted color='grey'/>
                                    {this.props.profileData.Patient_Data.location}{this.props.profileData.Patient_Data.birthPlace}
                                </Row>
                            :
                            null
                        }
                    </Col>
                </Row>
                <Row style={{width: "100%", backgroundColor: this.getTabRowColor()}}>
                    <Col style={{width:'100%', display: "flex", flexDirection: "row", justifyContent: "right", paddingRight:'1%'}}>
                        <Nav tabs id={this.getTabDisplay()}>
                            {this.props.subscription_info.features === undefined || Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("thermometer")) ?
                            <NavItem>
                                <Tooltip style={{ zIndex: 99 }} id="tooltip-tab-temperature">
                                    {this.select_tooltip("device.thermometer.name")}
                                </Tooltip>
                                <NavLink style={{backgroundColor:(this.state.frontend_alert_state.fever.triggered || this.state.frontend_alert_state.detach.triggered || this.state.frontend_alert_state.battery.triggered) ? "yellow" : ""}} className={this.state.activeTab === '1' ? 'active' : ''} onClick={() => {this.handleTabSwitch('1')}} data-tooltip-id="tooltip-tab-temperature" data-tooltip-place="top">
                                    <FaTemperatureHalf/>
                              </NavLink>
                            </NavItem>
                                :
                                null
                            }

                            {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("oximeter")) ?
                            <NavItem>
                                <Tooltip style={{ zIndex: 99 }} id="tooltip-tab-oximeter">
                                    {this.select_tooltip("device.oximeter.name")}
                                </Tooltip>
                                    <NavLink style={{backgroundColor:(this.state.frontend_alert_state.pulseRate.triggered || this.state.frontend_alert_state.spo2.triggered) ? "yellow" : ""}} className={this.state.activeTab === '2' ? 'active' : ''} onClick={()=>{this.handleTabSwitch('2')}} data-tooltip-id="tooltip-tab-oximeter" data-tooltip-place="top">
                                    <FaHeartPulse/>
                              </NavLink>
                            </NavItem>
                                :
                                null
                            }

                            {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("tensiometer")) ?
                            <NavItem>
                                <Tooltip style={{ zIndex: 99 }} id="tooltip-tab-tensiometer">
                                    {this.select_tooltip("device.tensiometer.name")}
                                </Tooltip>
                                    <NavLink style={{backgroundColor:(this.state.frontend_alert_state.pulseRateTension.triggered || this.state.frontend_alert_state.bloodpressure_sys_high.triggered || this.state.frontend_alert_state.bloodpressure_dia.triggered) ? "yellow" : ""}} className={this.state.activeTab === '3' ? 'active' : ''} onClick={()=>{this.handleTabSwitch('3')}} data-tooltip-id="tooltip-tab-tensiometer" data-tooltip-place="top">
                                    <img src={blood_pressure} style={{ height: "auto", maxHeight: "90%", width: "auto", maxWidth: "55px", filter: "invert(100%)"}} alt="blood_pressure"/>
                              </NavLink>
                            </NavItem>  
                                :
                                null
                            }

                            {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("scale")) ?
                            <NavItem>
                                <Tooltip style={{ zIndex: 99 }} id="tooltip-tab-scale">
                                    {this.select_tooltip("scale.form.title.main")}
                                </Tooltip>
                                    <NavLink style={{backgroundColor:(this.state.frontend_alert_state.weight.triggered) ? "yellow" : ""}}className={this.state.activeTab === '4' ? 'active' : ''} onClick={() => {this.handleTabSwitch('4')}} data-tooltip-id="tooltip-tab-scale" data-tooltip-place="top">
                                    <FaWeightScale/>
                              </NavLink>
                            </NavItem>  
                                :
                                null
                            }

                            {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("pain")) ?
                            <NavItem>
                                <Tooltip style={{ zIndex: 99 }} id="tooltip-tab-pain">
                                    {this.select_tooltip("param.pain")}
                                </Tooltip>
                                    <NavLink style={{backgroundColor:(this.state.frontend_alert_state.pain.triggered) ? "yellow" : ""}} className={this.state.activeTab === '5' ? 'active' : ''} onClick={()=>{this.handleTabSwitch('5')}} data-tooltip-id="tooltip-tab-pain" data-tooltip-place="top">
                                    <GiBackPain/>
                              </NavLink>
                            </NavItem>
                                :
                                null
                            }

                            {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_EQ5D")) ?
                            <NavItem>
                                    <Tooltip style={{ zIndex: 99 }} id="tooltip-tab-healthform_EQ5D">
                                    {this.select_tooltip("eq5d.form.title.main")}
                                </Tooltip>
                                    <NavLink  style={{backgroundColor:(this.state.frontend_alert_state.eq5d.triggered || this.state.frontend_alert_state.eq5d_scale.triggered) ? "yellow" : ""}} className={this.state.activeTab === '6' ? 'active' : ''} onClick={() => {this.handleTabSwitch('6')}} data-tooltip-id="tooltip-tab-healthform_EQ5D" data-tooltip-place="top">
                                    <RiSurveyLine/>
                              </NavLink>
                            </NavItem>
                                :
                                null
                            }
                          
                            {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_SF36")) ?
                                <NavItem>
                                    <Tooltip style={{ zIndex: 99 }} id="tooltip-tab-healthform_SF36">
                                        {this.select_tooltip("sf36.form.title.main")}
                                    </Tooltip>
                                    <NavLink style={{backgroundColor:(this.state.frontend_alert_state.sf36.triggered) ? "yellow" : ""}} className={this.state.activeTab === '16' ? 'active' : ''} onClick={() => {this.handleTabSwitch('16')}} data-tooltip-id="tooltip-tab-healthform_SF36" data-tooltip-place="top">
                                        <RiSurveyLine/>
                                  </NavLink>
                                </NavItem>
                                :
                                null
                            }
                          
                            {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_MDASI")) ?
                                <NavItem>
                                    <Tooltip style={{ zIndex: 99 }} id="tooltip-tab-healthform_MDASI">
                                        {this.select_tooltip("mdasi.form.title.main")}
                                    </Tooltip>
                                    <NavLink style={{backgroundColor:(this.state.frontend_alert_state.mdasi.triggered) ? "yellow" : ""}} className={this.state.activeTab === '17' ? 'active' : ''} onClick={() => {this.handleTabSwitch('17')}} data-tooltip-id="tooltip-tab-healthform_MDASI" data-tooltip-place="top">
                                        <RiSurveyLine/>
                                  </NavLink>
                                </NavItem>
                                :
                                null
                            }

                            {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_ALIMENTATION")) ?
                                <NavItem>
                                    <Tooltip style={{ zIndex: 99 }} id="tooltip-tab-healthform_ALIMENTATION">
                                        {this.select_tooltip("alimentation.form.title.main")}
                                    </Tooltip>
                                    <NavLink className={this.state.activeTab === '18' ? 'active' : ''} onClick={() => {this.handleTabSwitch('18')}} data-tooltip-id="tooltip-tab-healthform_ALIMENTATION" data-tooltip-place="top">
                                        <RiSurveyLine/>
                                    </NavLink>
                                </NavItem>
                                :
                                null
                            }

                            {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("picture")) ?
                                <NavItem>
                                    <Tooltip style={{ zIndex: 99 }} id="tooltip-tab-photo">
                                        {this.select_tooltip("picture.title.main")}
                                    </Tooltip>
                                    <NavLink className={this.state.activeTab === '20' ? 'active' : ''} onClick={() => {this.handleTabSwitch('20')}} data-tooltip-id="tooltip-tab-photo" data-tooltip-place="top">
                                        <FaCamera/>
                                    </NavLink>
                                </NavItem>
                                :
                                null
                            }

                            {(Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("kidney_failure"))) ?
                                <NavItem>
                                    <Tooltip style={{ zIndex: 99 }} id="tooltip-tab-kidney">
                                        {this.select_tooltip("kidney.form.title.main")}
                                    </Tooltip>
                                    <NavLink className={this.state.activeTab === '23' ? 'active' : ''} onClick={() => {this.handleTabSwitch('23')}} data-tooltip-id="tooltip-tab-kidney" data-tooltip-place="top">
                                        <GiKidneys />
                                    </NavLink>
                                </NavItem>
                                :
                                null
                            }

                            {(Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("niv"))) ?
                                <NavItem>
                                    <Tooltip style={{ zIndex: 99 }} id="tooltip-tab-niv">
                                        {this.select_tooltip("breathing.form.niv.title")}
                                    </Tooltip>
                                    <NavLink style={{backgroundColor:(this.state.frontend_alert_state.breathing_rate.triggered || this.state.frontend_alert_state.breathing_leakage.triggered) ? "yellow" : ""}} className={this.state.activeTab === '21' ? 'active' : ''} onClick={() => {this.handleTabSwitch('21')}} data-tooltip-id="tooltip-tab-niv" data-tooltip-place="top">
                                        <FaLungs/>
                                    </NavLink>
                                </NavItem>
                                :
                                null
                            }

                            {(Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("oxigen_therapy"))) ?
                                <NavItem>
                                    <Tooltip style={{ zIndex: 99 }} id="tooltip-tab-oxi">
                                        {this.select_tooltip("breathing.form.oxygen_therapy.title")}
                                    </Tooltip>
                                    <NavLink style={{backgroundColor:(this.state.frontend_alert_state.breathing_oxygen_rate.triggered || this.state.frontend_alert_state.pulseRate.triggered || this.state.frontend_alert_state.spo2.triggered ) ? "yellow" : ""}} className={this.state.activeTab === '22' ? 'active' : ''} onClick={() => {this.handleTabSwitch('22')}} data-tooltip-id="tooltip-tab-oxi" data-tooltip-place="top">
                                        <FaMaskVentilator/>
                                    </NavLink>
                                </NavItem>
                                :
                                null
                            }

                        </Nav>
                    </Col>
                </Row>
            </Row>
        )
    }


    
    // Function to fill the tooltip with different languages
    select_tooltip(type) {
        let def = "";
        switch (type) {
            case "param.tucky":
                def = "Temp";
                break;
            case "device.oximeter.name":
                def = "Oximeter";
                break;
            case "device.tensiometer.name":
                def = "Tensiometer";
                break;
            case "scale.form.title.main":
                def = "Scale";
                break;                
            case "param.pain":
                def = "Pain";
                break;
            case "eq5d.form.title.main":
                def = "Health Questionnaire (EQ5D)";
                break;
            case "sf36.form.title.main":
                def = "Health Questionnaire (SF36)"
                break
            case "mdasi.form.title.main":
                def = "Health Questionnaire (MDASI)"
                break
            case "alimentation.form.title.main":
                def = "Health Questionnaire (Alimentation)"
                break
            case "breathing.form.title.main":
                def = "Breathing"
                break
            case "picture.title.main":
                def = "Picture"
                break
            case "param.addmodulebutton.tooltip":
                def = "Add component alerts parameters"
                break
        }
        let ret = <FormattedMessage id={type} defaultMessage={def}/>
        return (ret)
    }

    getLastKidneyDeviceForm() {
      try {
        if (this.props.profileData.Patient_Data.kidney_device?.form_res.length > 0) {
          const kidney_data = this.props.profileData.Patient_Data.kidney_device.form_res;
          // get last entry
          return JSON.parse(kidney_data[kidney_data.length - 1].y);
        }
      } catch (e) {
        console.log("getLastKidneyDeviceForm : unable to get last kidney device form entry")
      }
      return undefined;
    }

    // Opens the zoomable graph in a modal (loupe icon). popupNum gives the
    // canvas a distinct id so it doesn't collide with the inline graph.
    openGraphPopup = (type) => {
        this.setState({
            graphPopup: {
                type: type,
                profileData: this.props.profileData,
                dateSelected: this.props.dateSelected,
                intl: this.props.intl,
                accountInformation: this.props.accountInformation,
                popupNum: 901,
            }
        });
    }

    closeGraphPopup = () => {
        this.setState({ graphPopup: null });
    }

    render(){
    	return(
            <div style={{width: "auto"}}>
                <div style={{width: this.getProfileWidth()}}>
                    <center>
                        <Card id={this.getCardIdAlert()}>
                            <Card id={this.getCardIdMonitoring()}>
                                {this.display_name_birthdate()}
                            </Card>
                            
                            {this.display_birthplace_tabs()}

                            <TabContent activeTab={this.state.activeTab}>

                                <TabPane tabId="1">
                                    <Card id="box-two">
                                        <Row id="banner-top">
                                            <TemperatureDisplay 
                                                alert={this.state.frontend_alert_state.fever.triggered} 
                                                temperatureDisplay={this.state.temperatureDisplay}
                                                maxTemperatureLast3h={this.state.maxTemperatureLast3h}
                                                DeviceSerialNumber={this.props.profileData.Patient_Data.devices.device1.sn}
                                            />
                                            {!(this.props.profileData.Patient_Data.devices.device1.sn || '').includes('-') ?
                                            <PositionDisplay 
                                                alert={this.state.frontend_alert_state.position.triggered} 
                                                position={this.state.positionDisplay}
                                            />
                                            :
                                            null
                                            }
                                            {!(this.props.profileData.Patient_Data.devices.device1.sn || '').includes('-') ?
                                            <BatteryDisplay 
                                                alert={this.state.frontend_alert_state.battery.triggered} 
                                                batteryLevel={this.state.batteryLevelDisplay}
                                            />
                                            :
                                            null
                                            }
                                        </Row>
                                        {this.props.subscription_info.features === undefined || Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("thermometer")) ?
                                        <TimerDisplay 
                                            timerDisplayString={this.state.temperatureTimerDisplay}
                                        />
                                            :
                                            null
                                        }
                                    </Card>
                                    {(this.props.extendedView === "graph") ? 
                                        <div>
                                            <Card id="box-extended-view2">
                                                {this.props.subscription_info.features === undefined || Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("thermometer")) ?
                                                    Utils.display_temperatureGraph({...this.props, onEnlarge: () => this.openGraphPopup("tuckyTemperature")})
                                                    :
                                                    null
                                                }
                                            </Card>
                                        </div>
                                        : 
                                        null
                                    }
                                </TabPane>

                                <TabPane tabId="2">
                                    <Card id="box-two">
                                        {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("oximeter")) || Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("niv")) || Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("oxigen_therapy")) ?
                                        <Row id="banner-top">
                                            <div style={{width: "50%"}}>                                        
                                                <PulseRateDisplay 
                                                    alert={this.state.frontend_alert_state.pulseRate.triggered} 
                                                    pulseRateDisplay={this.state.pulseRateDisplay}
                                                />
                                            </div>
                                            <div style={{width: "50%"}}>                                                
                                                <Sp02Display 
                                                    alert={this.state.frontend_alert_state.spo2.triggered} 
                                                    spo2Display={this.state.spo2Display}
                                                />
                                            </div>                                                
                                        </Row>
                                            :
                                            null
                                        }
                                        {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("oximeter")) || Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("niv")) || Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("oxigen_therapy")) ?
                                        <Row>
                                            <TimerDisplay 
                                                timerDisplayString={this.state.spo2PrTimerDisplay}
                                            />
                                        </Row>
                                            :
                                            null
                                        }
                                    </Card>
                                    {(this.props.extendedView === "graph") ? 
                                        <div>
                                            <Card id="box-extended-view2">
                                            {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("oximeter")) || Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("niv")) || Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("oxigen_therapy")) ?
                                                Utils.display_pulseOximeterGraph({...this.props, onEnlarge: () => this.openGraphPopup("oximeterPulseRate")}, 102)
                                                :
                                                null
                                            }
                                            </Card>
                                        </div>
                                        : 
                                        null
                                    }
                                </TabPane>

                                <TabPane tabId="3">
                                    <Card id="box-two">
                                        {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("tensiometer")) ?
                                        <Row id="banner-top">
                                            <div style={{width: "50%"}}>
                                                <PulseRateDisplay 
                                                    alert={this.state.frontend_alert_state.pulseRateTension.triggered}
                                                    pulseRateDisplay={this.state.pulseRateDisplayTensiometer}
                                                />
                                            </div>
                                            <div style={{width: "50%"}}>
                                                <TensionDisplay
                                                    alert={this.state.frontend_alert_state.bloodpressure_sys_high.triggered}
                                                    tensionDisplay={this.state.tensionDisplay}
                                                />
                                            </div>                                                
                                        </Row>
                                            :
                                            null
                                        }
                                        {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("tensiometer")) ?
                                        <Row>
                                            <TimerDisplay 
                                                timerDisplayString={this.state.tensionTimerDisplay}
                                            />
                                        </Row>
                                            :
                                            null
                                        }
                                    </Card>
                                    {(this.props.extendedView === "graph") ?
                                        <div>
                                            <Card id="box-extended-view2">
                                                {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("tensiometer")) ?
                                                    Utils.display_tensiometerGraph({...this.props, onEnlarge: () => this.openGraphPopup("tensiometerBloodpressure")})
                                                    :
                                                    null
                                                }
                                            </Card>
                                        </div>
                                        :
                                        null
                                    }
                                </TabPane>

                                <TabPane tabId="4">
                                    <Card id="box-two">
                                        {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("scale")) ?
                                        <Row id="banner-top">
                                            <div style={{width: "50%"}}>                                        
                                                <WeightDisplay
                                                    alert={this.state.frontend_alert_state.weight.triggered}
                                                    weightDisplay={this.state.weightDisplay}
                                                />
                                            </div>
                                        </Row>
                                            :
                                            null
                                        }
                                        {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("scale")) ?
                                        <Row>
                                            <TimerDisplay 
                                                timerDisplayString={this.state.weightTimerDisplay}
                                            />
                                        </Row>                                        
                                            :
                                            null
                                        }
                                    </Card>
                                    {(this.props.extendedView === "graph") ?
                                        <div>
                                            <Card id="box-extended-view2">
                                                {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("scale")) ?
                                                    Utils.display_scaleGraph({...this.props, onEnlarge: () => this.openGraphPopup("scaleWeight")})
                                                    :
                                                    null
                                                }
                                            </Card>
                                        </div>
                                        :
                                        null
                                    }
                                </TabPane>                                                              

                                <TabPane tabId="5">
                                    <Card id="box-two">
                                        <Row id="banner-top">
                                            {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("pain")) ?
                                                this.renderPainScale()
                                                :
                                                null
                                            }
                                        </Row>
                                    </Card>
                                    {(this.props.extendedView === "graph") ?
                                        <div>
                                            <Card id="box-extended-view2">
                                                {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("pain")) ?
                                                    Utils.display_painGraph({...this.props, onEnlarge: () => this.openGraphPopup("pain")})
                                                    :
                                                    null
                                                }
                                            </Card>
                                        </div>
                                        :
                                        null
                                    }
                                </TabPane>

                                <TabPane tabId="6">
                                    <Card id="box-two">
                                        {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_EQ5D")) ?
                                        <Row id="banner-top">
                                            <div style={{width: "40%"}}>                                        
                                                <EQ5DResDisplay
                                                        alert={this.state.frontend_alert_state.eq5d.triggered}
                                                    formresDisplay={this.state.formresDisplay}
                                                    id_patient={this.props.profileData.Patient_Data.id_patient}
                                                />
                                            </div>                                                
                                            <div style={{width: "40%"}}>                                        
                                                <EQ5DHealthscaleDisplay
                                                        alert={this.state.frontend_alert_state.eq5d_scale.triggered}
                                                    healthscaleDisplay={this.state.healthscaleDisplay}
                                                    id_patient={this.props.profileData.Patient_Data.id_patient}
                                                />
                                            </div>                                                                                                
                                                {this.props.profileData.Patient_Data.monitoring_activation !== "no" ?
                                            <div style={{width: "20%"}}>                                        
                                                <EQ5DDisplayNewForm
                                                    id_patient={this.props.profileData.Patient_Data.id_patient}
                                                    update={this.healthformEQ5DUpdate}
                                                    screenSize={this.props.screenSize}
                                                            subscription_info={this.props.subscription_info}
                                                            accountInformation={this.props.accountInformation}
                                                />
                                            </div>                                                                                                
                                                    :
                                                    null
                                                }
                                        </Row>
                                            :
                                            null
                                        }
                                        {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_EQ5D")) ?
                                        <Row>
                                            <TimerDisplay 
                                                timerDisplayString={this.state.formTimerDisplay}
                                            />
                                        </Row>                                         
                                            :
                                            null
                                        }
                                    </Card>
                                    {(this.props.extendedView === "graph") ?
                                        <div>
                                            <Card id="box-extended-view2">
                                                {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_EQ5D")) ?
                                                    this.display_formEQ5DGraph()
                                                    :
                                                    null
                                                }
                                            </Card>
                                        </div>
                                        :
                                        null
                                    }
                                </TabPane>   

                                <TabPane tabId="16">
                                    <Card id="box-two">
                                        {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_SF36")) ?
                                            <Row id="banner-top">
                                                <div style={{width: "80%"}}>
                                                    <SF36ResDisplay
                                                        alert={this.state.frontend_alert_state.sf36.triggered}
                                                        formresSF36Display={this.state.formresSF36Display}
                                                        id_patient={this.props.profileData.Patient_Data.id_patient}
                                                    />
                                                </div>                                                
                                                {this.props.profileData.Patient_Data.monitoring_activation !== "no" ?
                                                <div style={{width: "20%"}}>                                        
                                                    <SF36DisplayNewForm 
                                                        id_patient={this.props.profileData.Patient_Data.id_patient}
                                                        update={this.healthformSF36Update}
                                                        screenSize={this.props.screenSize}
                                                        intl={this.props.intl}
                                                            accountInformation={this.props.accountInformation}
                                                            subscription_info={this.props.subscription_info}
                                                    />
                                                </div>                                                                                                
                                                    :
                                                    null
                                                }
                                            </Row>
                                            :
                                            null
                                        }
                                        {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_SF36")) ?
                                            <Row>
                                                <TimerDisplay 
                                                    timerDisplayString={this.state.formSF36TimerDisplay}
                                                />
                                            </Row>
                                            :
                                            null
                                        }
                                    </Card>
                                    {(this.props.extendedView === "graph") ?
                                        <div>
                                            <Card id="box-extended-view2">
                                                {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_SF36")) ?
                                                    this.display_formSF36Graph()
                                                    :
                                                    null
                                                }
                                            </Card>
                                        </div>
                                        :
                                        null
                                    }
                                </TabPane>   

                                <TabPane tabId="17">
                                    <Card id="box-two">
                                        {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_MDASI")) ?
                                            <Row id="banner-top">
                                                <div style={{width: "80%"}}>                      
                                                    <MDASIResDisplay
                                                        alert={this.state.frontend_alert_state.mdasi.triggered}
                                                        formresmdasiDisplay={this.state.formresMDASIDisplay}
                                                        id_patient={this.props.profileData.Patient_Data.id_patient}
                                                    />
                                                </div>                                                
                                                <div style={{width: "20%"}}>                                        
                                                    {this.props.profileData.Patient_Data.monitoring_activation !== "no" ?
                                                    <MDASIDisplayNewForm 
                                                        id_patient={this.props.profileData.Patient_Data.id_patient}
                                                        update={this.healthformMDASIUpdate}
                                                        screenSize={this.props.screenSize}
                                                            intl={this.props.intl}
                                                            accountInformation={this.props.accountInformation}
                                                            subscription_info={this.props.subscription_info}
                                                    />
                                                        :
                                                        null
                                                    }
                                                </div>                                                                                                
                                            </Row>
                                            :
                                            null
                                        }
                                        {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_MDASI")) ?
                                            <Row>
                                                <TimerDisplay 
                                                    timerDisplayString={this.state.formMDASITimerDisplay}
                                                />
                                            </Row>
                                            :
                                            null
                                        }
                                    </Card>
                                    {(this.props.extendedView === "graph") ?
                                        <div>
                                            <Card id="box-extended-view2">
                                                {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_MDASI")) ?
                                                    this.display_formMDASIGraph()
                                                    :
                                                    null
                                                }
                                            </Card>
                                        </div>
                                        :
                                        null
                                    }
                                </TabPane>

                                <TabPane tabId="18">
                                    <Card id="box-two">
                                        {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_ALIMENTATION")) ?
                                            <Row id="banner-top">
                                                <div style={{width: "80%"}}>
                                                    <AlimentationResDisplay
                                                        formresAlimentationDisplay={this.state.formresAlimentationDisplay}
                                                        id_patient={this.props.profileData.Patient_Data.id_patient}
                                                    />
                                                </div>
                                                <div style={{width: "20%"}}>
                                                    {this.props.profileData.Patient_Data.monitoring_activation !== "no" ?
                                                    <AlimentationDisplayNewForm 
                                                        id_patient={this.props.profileData.Patient_Data.id_patient}
                                                        update={this.healthformAlimentationUpdate}
                                                        screenSize={this.props.screenSize}
                                                        intl={this.props.intl}
                                                            accountInformation={this.props.accountInformation}
                                                            subscription_info={this.props.subscription_info}
                                                    />
                                                        :
                                                        null
                                                    }
                                                </div>                                                                                                
                                            </Row>
                                            :
                                            null
                                        }
                                        {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_ALIMENTATION")) ?
                                            <Row>
                                                <TimerDisplay 
                                                    timerDisplayString={this.state.formAlimentationTimerDisplay}
                                                />
                                            </Row>
                                            :
                                            null
                                        }
                                    </Card>
                                    {(this.props.extendedView === "graph") ?
                                        <div>
                                            <Card id="box-extended-view2">
                                                {(Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("healthform_ALIMENTATION")) && (this.props.profileData.Patient_Data.alimentation.form_res.length > 0)) ?
                                                    this.display_formAlimentationGraph()
                                                    :
                                                    null
                                                }
                                            </Card>
                                        </div>
                                        :
                                        null
                                    }
                                </TabPane>

                                <TabPane tabId="20">
                                    <Card id="box-two">
                                        {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("picture")) ?
                                            <Row id="banner-top">
                                                <div style={{width: "80%"}}>
                                                </div>
                                                <div style={{width: "20%"}}>
                                                    {this.props.profileData.Patient_Data.monitoring_activation !== "no" ?
                                                    <CameraPopup
                                                        id_patient={this.props.profileData.Patient_Data.id_patient}
                                                        update={this.photoUpdate}
                                                        screenSize={this.props.screenSize}
                                                            subscription_info={this.props.subscription_info}
                                                            accountInformation={this.props.accountInformation}
                                                    />
                                                        :
                                                        null
                                                    }
                                                </div>
                                            </Row>
                                            :
                                            null
                                        }
                                    </Card>
                                    {(this.props.extendedView === "graph") ?
                                        <div>
                                            <Card id="box-extended-view2">
                                                {(Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("picture")) && (this.props.profileData.Patient_Data.photo.length > 0)) ? 
                                                    this.displayPhotoCarousel()
                                                    :
                                                    null
                                                }
                                            </Card>
                                        </div>
                                        :
                                        null
                                    }
                                </TabPane>

                                <TabPane tabId="21">
                                    <Card id="box-two">
                                        {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("niv")) ?
                                            <Row id="banner-top">
                                                <div style={{width: "20%"}}>
                                                    <NivBreathingUsageResDisplay
                                                        formresBreathingDisplay={this.state.breathingUsageNivDisplay}
                                                        id_patient={this.props.profileData.Patient_Data.id_patient}
                                                    />
                                                </div>
                                                <div style={{width: "20%"}}>
                                                    <NivBreathingLeakageResDisplay
                                                        formresBreathingDisplay={this.state.breathingLeakNivDisplay}
                                                        id_patient={this.props.profileData.Patient_Data.id_patient}
                                                        breathing_data={this.props.profileData.Patient_Data.breathing}
                                                    />
                                                </div>
                                                <div style={{width: "20%"}}>
                                                    <NivBreathingRateResDisplay
                                                        breathingRateNivDisplay={this.state.breathingRateNivDisplay}
                                                        id_patient={this.props.profileData.Patient_Data.id_patient}
                                                    />
                                                </div>
                                                <div style={{width: "20%"}}>
                                                    <AhiIndexResDisplay
                                                        ahiIndexDisplay={this.state.ahiIndexDisplay}
                                                        id_patient={this.props.profileData.Patient_Data.id_patient}
                                                    />
                                                </div>
                                                <div style={{width: "20%"}}>
                                                    {(this.props.profileData.Patient_Data.monitoring_activation === "no" || this.props.profileData.Patient_Data.niv_provider !== "internal") ?
                                                      null
                                                      :
                                                    <NivDisplayNewForm 
                                                        id_patient={this.props.profileData.Patient_Data.id_patient}
                                                        update={this.breathingUpdate}
                                                        breathing={this.props.profileData.Patient_Data.breathing}
                                                        start_date={new Date(this.props.dateSelected[0]).getTime()}
                                                        end_date={new Date(this.props.dateSelected[1]).getTime()}
                                                        screenSize={this.props.screenSize}
                                                            accountInformation={this.props.accountInformation}
                                                    />
                                                    }
                                                </div>
                                            </Row>
                                            :
                                            null
                                        }
                                        {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("niv")) ?
                                            <Row>
                                                <TimerDisplay 
                                                    timerDisplayString={this.state.formNivTimerDisplay}
                                                />
                                            </Row>
                                            :
                                            null
                                        }
                                    </Card>
                                    {(this.props.extendedView === "graph") ?
                                        <div>
                                            <Card id="box-extended-view2">
                                                {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("niv")) ? 
                                                    this.display_breathingGraphs_NIV()
                                                    :
                                                    null
                                                }
                                            </Card>
                                        </div>
                                        :
                                        null
                                    }
                                </TabPane>

                                <TabPane tabId="22">
                                    <Card id="box-two">
                                        {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("oxigen_therapy")) ?
                                            <Row id="banner-top">
                                                <div style={{width: "40%"}}>
                                                    <OxiUsageDisplay
                                                        formresBreathingDisplay={this.state.formresOxiUsageDisplay}
                                                        id_patient={this.props.profileData.Patient_Data.id_patient}
                                                    />
                                                </div>
                                                <div style={{width: "40%"}}>
                                                    <OxiResDisplay
                                                        formresBreathingDisplay={this.state.formresOxiBreathingRateDisplay}
                                                        id_patient={this.props.profileData.Patient_Data.id_patient}
                                                    />
                                                </div>
                                                <div style={{width: "20%"}}>
                                                    {this.props.profileData.Patient_Data.monitoring_activation !== "no" ?
                                                    <OxiDisplayNewForm 
                                                        id_patient={this.props.profileData.Patient_Data.id_patient}
                                                        update={this.breathingUpdate}
                                                        breathing={this.props.profileData.Patient_Data.breathing}
                                                        start_date={new Date(this.props.dateSelected[0]).getTime()}
                                                        end_date={new Date(this.props.dateSelected[1]).getTime()}
                                                        screenSize={this.props.screenSize}
                                                            accountInformation={this.props.accountInformation}
                                                    />
                                                        :
                                                        null
                                                    }
                                                </div>
                                            </Row>
                                            :
                                            null
                                        }
                                        {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("oxigen_therapy")) ?
                                            <Row>
                                                <TimerDisplay 
                                                    timerDisplayString={this.state.formOxiTimerDisplay}
                                                />
                                            </Row>
                                            :
                                            null
                                        }
                                    </Card>
                                    {(this.props.extendedView === "graph") ?
                                        <div>
                                            <Card id="box-extended-view2">
                                                {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("oxigen_therapy")) ? 
                                                    this.display_breathingGraphs_oxy()
                                                    :
                                                    null
                                                }
                                            </Card>
                                        </div>
                                        :
                                        null
                                    }
                                </TabPane>
                  
                                {(Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("kidney_failure"))) ?
                                <TabPane tabId="23">
                                    <Card id="box-two">
                                        <Row id="banner-top">
                                            <div style={{width: "50%"}}>
                                            </div>
                                            <div style={{ width: "25%" }}>
                                              {(this.props.profileData.Patient_Data.monitoring_activation === "no") ?
                                                      null
                                                    :
                                                <KidneyBloodDisplayNewForm 
                                                    id_patient={this.props.profileData.Patient_Data.id_patient}
                                                    update={this.kidneyBloodUpdate}
                                                    intl={this.props.intl}
                                                    screenSize={this.props.screenSize}
                                                    accountInformation={this.props.accountInformation}
                                                />
                                                }
                                            </div>
                                            <div style={{width: "25%"}}>
                                                {(this.props.profileData.Patient_Data.monitoring_activation === "no") ?
                                                    null
                                                    :
                                                <KidneyMachineDisplayNewForm 
                                                    id_patient={this.props.profileData.Patient_Data.id_patient}
                                                    update={this.kidneyDeviceUpdate}
                                                    lastKidneyDeviceForm={this.getLastKidneyDeviceForm()}
                                                    start_date={new Date(this.props.dateSelected[0]).getTime()}
                                                    end_date={new Date(this.props.dateSelected[1]).getTime()}
                                                    intl={this.props.intl}
                                                    screenSize={this.props.screenSize}
                                                    accountInformation={this.props.accountInformation}
                                                />
                                                }
                                            </div>
                                        </Row>
                                    </Card>
                                      <Card id="box-two">
                                        {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("tensiometer")) ?
                                        <Row id="banner-top">
                                            <div style={{width: "50%"}}>
                                                <PulseRateDisplay 
                                                    alert={this.state.frontend_alert_state.pulseRateTension.triggered}
                                                    pulseRateDisplay={this.state.pulseRateDisplayTensiometer}
                                                />
                                            </div>
                                            <div style={{width: "50%"}}>
                                                <TensionDisplay
                                                    alert={this.state.frontend_alert_state.bloodpressure_sys_high.triggered}
                                                    tensionDisplay={this.state.tensionDisplay}
                                                />
                                            </div>
                                        </Row>
                                            :
                                            null
                                        }
                                        {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("tensiometer")) ?
                                        <Row>
                                            <TimerDisplay 
                                                timerDisplayString={this.state.tensionTimerDisplay}
                                            />
                                        </Row>
                                            :
                                            null
                                        }
                                    </Card>
                                    {(this.props.extendedView === "graph") ?
                                        <div>
                                            <Card id="box-extended-view2">
                                                {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("tensiometer")) ?
                                                    Utils.display_tensiometerGraph({...this.props, onEnlarge: () => this.openGraphPopup("tensiometerBloodpressure")}, null, 202)
                                                    :
                                                    null
                                                }
                                            </Card>
                                        </div>
                                        :
                                        null
                                    }
                                    <Card id="box-two">
                                        {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("scale")) ?
                                        <Row id="banner-top">
                                            <div style={{width: "50%"}}>
                                                <WeightDisplay
                                                    alert={this.state.frontend_alert_state.weight.triggered}
                                                    weightDisplay={this.state.weightDisplay}
                                                />
                                            </div>
                                        </Row>
                                            :
                                            null
                                        }
                                        {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("scale")) ?
                                        <Row>
                                            <TimerDisplay 
                                                timerDisplayString={this.state.weightTimerDisplay}
                                            />
                                        </Row>
                                            :
                                            null
                                        }
                                    </Card>
                                    {(this.props.extendedView === "graph") ?
                                        <div>
                                            <Card id="box-extended-view2">
                                                {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("scale")) ?
                                                    Utils.display_scaleGraph({...this.props, onEnlarge: () => this.openGraphPopup("scaleWeight")}, null, 303)
                                                    :
                                                    null
                                                }
                                            </Card>
                                        </div>
                                        :
                                        null
                                      }
                                      <Card id="box-two">
                                        {Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("picture")) ?
                                            <Row id="banner-top">
                                                <div style={{width: "80%"}}>
                                                </div>
                                                <div style={{width: "20%"}}>
                                                    {this.props.profileData.Patient_Data.monitoring_activation !== "no" ?
                                                    <CameraPopup
                                                        id_patient={this.props.profileData.Patient_Data.id_patient}
                                                        update={this.photoUpdate}
                                                        screenSize={this.props.screenSize}
                                                            subscription_info={this.props.subscription_info}
                                                            accountInformation={this.props.accountInformation}
                                                    />
                                                        :
                                                        null
                                                    }
                                                </div>
                                            </Row>
                                            :
                                            null
                                        }
                                    </Card>
                                    {(this.props.extendedView === "graph") ?
                                        <div>
                                            <Card id="box-extended-view2">
                                                {(Utils.checkBit(this.props.subscription_info.features, Utils.featureToBitNumber("picture")) && (this.props.profileData.Patient_Data.photo.length > 0)) ? 
                                                    this.displayPhotoCarousel()
                                                    :
                                                    null
                                                }
                                            </Card>
                                        </div>
                                        :
                                        null
                                        }
                                        {(this.props.extendedView === "graph") ?
                                        <div>
                                            <Card id="box-extended-view2">
                                                { this.display_kidneyDeviceTable() }
                                            </Card>
                                            <Card id="box-extended-view2">
                                                { this.display_kidneyBloodTable() }
                                            </Card>
                                        </div>
                                        :
                                        null
                                    }
                                </TabPane>
                                :
                                  null
                                }

                                    {(this.props.extendedView === "parameters") ?
                                        <div className="patient-params-container">
                                        <ProfileParameters
                                            profileData = {this.props.profileData}
                                            updateProfileParameters = {this.props.updateProfileParameters}
                                            structure_groups={this.props.structure_groups}
                                            structure_devices={this.props.structure_devices}
                                            structure_gateways={this.props.structure_gateways}
                                            accountInformation={this.props.accountInformation}
                                            reloadUserAndProfiles={this.props.reloadUserAndProfiles}
                                            structure_Id={this.props.structure_Id}
                                            subscription_info={this.props.subscription_info}
                                            userRole={this.props.userRole}
                                            tabColor={this.getTabRowColor()}
                                            select_tooltip={this.props.select_tooltip}
                                            displayDevicesParams={this.state.displayDevicesParams}
                                            changeDisplayDevices={this.changeDisplayDevices}
                                            changeOngoing={this.state.changeOngoing}
                                            setChangeOngoing={this.handleChangeOngoing}
                                            hidePatientIds={this.props.hidePatientIds}
                                        />
                                        </div>
                                        :
                                        null
                                    }
                            </TabContent>
                        </Card>
                    </center>
                </div>
                {this.state.showProfileModal && (
                    <PatientProfileModal
                        patientData={this.props.profileData.Patient_Data}
                        cancelPopup={() => this.setState({ showProfileModal: false })}
                        subscription_info={this.props.subscription_info}
                        tlsSubscriptionFeatures={this.props.viewerSubscriptionFeatures ?? this.props.subscription_info?.features}
                        dateSelected={this.props.dateSelected}
                        intl={this.props.intl}
                        accountInformation={this.props.accountInformation}
                        hidePatientIds={this.props.hidePatientIds}
                    />
                )}
                {this.state.graphPopup && (
                    <GraphPopup
                        inside_props={this.state.graphPopup}
                        onClose={this.closeGraphPopup}
                    />
                )}
            </div>
    	);
    }
}
export default (Profile);
